<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <v-autocomplete
              :items="allQuotationType"
              item-text="Name"
              item-value="Type"
              :label="$t('quotation_name')"
              v-model="filterQuotation.Type"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
              :loading="isLoadingQuotation"
              @change="onFilterChange"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_number')"
              v-model="filterQuotation.Number"
              @input="onFilterChange"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_subject')"
              v-model="filterQuotation.Subject"
              @input="onFilterChange"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-autocomplete
              :items="allSpecialNeedList"
              item-text="Name"
              item-value="Id"
              :label="$t('quotation_special_need')"
              v-model="filterQuotation.SpecialNeedId"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
              :loading="isLoadingQuotation"
              @change="onFilterChange"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterQuotation"
              :editedCustomerIndex="-1"
              :customerName="'quotation_customer_number'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterQuotation.LicensePlate"
              @input="onFilterChange"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_original_license_plate')"
              v-model="filterQuotation.OriginalLicensePlate"
              @input="onFilterChange"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-menu
              v-model="signDateStartMenu"
              :close-on-content-click="false"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filterQuotation.SignDateStart"
                  label="客戶回簽日（起）"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  clearable
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="clearSignDateStart"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filterQuotation.SignDateStart"
                locale="zh-tw"
                @change="onSignDateStartChange"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-menu
              v-model="signDateEndMenu"
              :close-on-content-click="false"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filterQuotation.SignDateEnd"
                  label="客戶回簽日（迄）"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  clearable
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="clearSignDateEnd"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filterQuotation.SignDateEnd"
                locale="zh-tw"
                @change="onSignDateEndChange"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="quotationDataTableHeaders"
      :items="quotationList"
      class="elevation-1 mt-5"
      show-expand
      :expanded.sync="expandedQuotations"
      item-key="Id"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :loading="isLoadingQuotation"
      :loading-text="$t('common_get_data')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('quotation_tool_bar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2 ml-8" @click="openHardwareSummary">
            條件匯總報表
          </v-btn>

          <v-dialog persistent v-model="isShowHardwareSummaryDialog" fullscreen>
            <v-card>
              <v-card-title>
                條件匯總報表
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mr-2" :disabled="!hardwareSummaryRows.length">
                  下載
                </v-btn>
                <v-btn text @click="isShowHardwareSummaryDialog = false">
                  {{ $t('common_close') }}
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="hardwareSummaryHeaders"
                  :items="hardwareSummaryRows"
                  show-expand
                  :expanded.sync="expandedSummaryRows"
                  item-key="Id"
                  :no-data-text="$t('common_no_data')"
                  disable-pagination
                  hide-default-footer
                  class="elevation-1"
                >
                  <template v-slot:[`item.data-table-expand`]="{ item, isExpanded, expand }">
                    <v-btn
                      v-if="item.HardwareItems.length"
                      icon
                      small
                      @click.stop="expand(!isExpanded)"
                    >
                      <v-icon>{{ isExpanded ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:[`item.SignDateText`]="{ item }">
                    {{ item.SignDateText }}
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-3">
                      <v-simple-table dense>
                        <thead>
                          <tr>
                            <th>品號</th>
                            <th>品名</th>
                            <th>數量</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, idx) in item.HardwareItems" :key="idx">
                            <td>{{ row.Number }}</td>
                            <td>{{ row.Name }}</td>
                            <td>{{ row.Quantity }}</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </td>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-btn
            color="primary"
            dark
            class="mb-2 ml-8"
            v-if="isRoleAdmin"
            @click="isShowChangeDetailPageDialog = true"
          >
            變更車牌、抬頭頁面
          </v-btn>
          <v-dialog persistent v-model="isShowChangeDetailPageDialog" fullscreen>
            <v-card>
              <v-card-title>變更車牌、抬頭頁面</v-card-title>
              <quotation-change-detail />
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="isShowChangeDetailPageDialog = false">
                  {{ $t('common_close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn color="primary" dark class="mb-2 ml-8" @click="isShowSelectMergeQuotationBtn">
            合併報價單
          </v-btn>
          <select-merge-quotation ref="selectMergeQuotation" @getAllQuotation="getAllQuotation" />
          <v-btn color="primary" dark class="mb-2 ml-8" @click="isOpenQuotation">
            {{ $t('quotation_new_btn') }}
          </v-btn>
          <v-dialog
            persistent
            v-model="isShowEditQuotationDialog"
            v-if="isShowEditQuotationDialog"
            fullscreen
          >
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ quotationDialogTitle }}</span>
                <v-spacer></v-spacer>
                <v-btn text small @click="closeEditedQuotation" class="mx-2">
                  <v-icon>
                    mdi-close-circle-outline
                  </v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-row class="mt-2">
                  <v-btn
                    v-if="isRoleManagerOrAdmin"
                    color="primary"
                    @click="isConfirmQuotationBtn"
                    :disabled="
                      editedQuotation.IsConfirmQuotation ||
                        editedQuotation.IsInvalid ||
                        editedQuotationIndex === -1 ||
                        !isAllTextFieldDisabled
                    "
                    class="mx-2"
                  >
                    {{ $t('quotation_tool_is_confirm_quotation') }}
                  </v-btn>

                  <!-- 簽核前顯示預覽按鈕，簽核後切換為正式匯出按鈕 -->
                  <v-btn
                    color="warning"
                    :disabled="editedQuotation.IsInvalid || editedQuotationIndex === -1"
                    class="mx-2"
                    @click="exportInstallQuotation(true)"
                    v-if="
                      editedQuotation.Type === quotationType.TypeNewInstall &&
                        !editedQuotation.IsConfirmQuotation
                    "
                  >
                    預覽新裝機報價單
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotation.IsInvalid ||
                        editedQuotationIndex === -1 ||
                        editedQuotation.IsConfirm
                    "
                    class="mx-2"
                    @click="exportInstallQuotation()"
                    v-if="
                      editedQuotation.Type === quotationType.TypeNewInstall &&
                        editedQuotation.IsConfirmQuotation
                    "
                  >
                    {{ $t('quotation_tool_install_export_quotation') }}
                  </v-btn>
                  <!-- 簽核前顯示預覽按鈕，簽核後切換為正式匯出按鈕 -->
                  <v-btn
                    color="warning"
                    :disabled="
                      editedQuotation.IsInvalid || editedQuotationIndex === -1 || isLoadingQuotation
                    "
                    class="mx-2"
                    @click="exportOffsetQuotation(true)"
                    v-if="
                      (editedQuotation.Type === quotationType.TypeRepair ||
                        editedQuotation.Type === quotationType.TypeOffset) &&
                        !editedQuotation.IsConfirmQuotation
                    "
                  >
                    預覽報價單
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotation.IsInvalid ||
                        editedQuotationIndex === -1 ||
                        isLoadingQuotation ||
                        editedQuotation.IsConfirm
                    "
                    class="mx-2"
                    @click="exportOffsetQuotation()"
                    v-if="
                      (editedQuotation.Type === quotationType.TypeRepair ||
                        editedQuotation.Type === quotationType.TypeOffset) &&
                        editedQuotation.IsConfirmQuotation
                    "
                  >
                    匯出報價單
                  </v-btn>
                  <!-- 簽核前顯示預覽按鈕，簽核後切換為正式匯出按鈕 -->
                  <v-btn
                    color="warning"
                    :disabled="editedQuotation.IsInvalid || editedQuotationIndex === -1"
                    class="mx-2"
                    @click="exportInstallQuotation(true)"
                    v-if="
                      (editedQuotation.Type === quotationType.TypeMonth ||
                        editedQuotation.Type === quotationType.TypeProject) &&
                        !editedQuotation.IsConfirmQuotation
                    "
                  >
                    預覽報價單
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotation.IsInvalid ||
                        editedQuotationIndex === -1 ||
                        editedQuotation.IsConfirm
                    "
                    class="mx-2"
                    @click="exportInstallQuotation()"
                    v-if="
                      (editedQuotation.Type === quotationType.TypeMonth ||
                        editedQuotation.Type === quotationType.TypeProject) &&
                        editedQuotation.IsConfirmQuotation
                    "
                  >
                    匯出報價單
                  </v-btn>
                  <!-- 簽核前顯示預覽按鈕，簽核後切換為正式匯出按鈕 -->
                  <v-btn
                    color="warning"
                    :disabled="editedQuotation.IsInvalid || editedQuotationIndex === -1"
                    class="mx-2"
                    @click="exportProjectPayItemQuotation(true)"
                    v-if="
                      editedQuotation.Type === quotationType.TypeProjectPayItem &&
                        !editedQuotation.IsConfirmQuotation
                    "
                  >
                    預覽報價單
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotation.IsInvalid ||
                        editedQuotationIndex === -1 ||
                        editedQuotation.IsConfirm
                    "
                    class="mx-2"
                    @click="exportProjectPayItemQuotation()"
                    v-if="
                      editedQuotation.Type === quotationType.TypeProjectPayItem &&
                        editedQuotation.IsConfirmQuotation
                    "
                  >
                    匯出報價單
                  </v-btn>
                  <!-- 簽核前顯示預覽按鈕，簽核後切換為正式匯出按鈕 -->
                  <v-btn
                    color="warning"
                    :disabled="editedQuotation.IsInvalid || editedQuotationIndex === -1"
                    class="mx-2"
                    @click="exportRemoveQuotation(true)"
                    v-if="
                      editedQuotation.Type === quotationType.TypeRemoveCar &&
                        !editedQuotation.IsConfirmQuotation
                    "
                  >
                    預覽拆機報價單
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotation.IsInvalid ||
                        editedQuotationIndex === -1 ||
                        editedQuotation.IsConfirm
                    "
                    class="mx-2"
                    @click="exportRemoveQuotation()"
                    v-if="
                      editedQuotation.Type === quotationType.TypeRemoveCar &&
                        editedQuotation.IsConfirmQuotation
                    "
                  >
                    {{ $t('quotation_tool_remove_export_quotation') }}
                  </v-btn>
                  <!-- 簽核前顯示預覽按鈕，簽核後切換為正式匯出按鈕 -->
                  <v-btn
                    color="warning"
                    :disabled="editedQuotation.IsInvalid || editedQuotationIndex === -1"
                    class="mx-2"
                    @click="exportReturnQuotation(true)"
                    v-if="
                      editedQuotation.Type === quotationType.TypeReturnCar &&
                        !editedQuotation.IsConfirmQuotation
                    "
                  >
                    預覽回裝報價單
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotation.IsInvalid ||
                        editedQuotationIndex === -1 ||
                        editedQuotation.IsConfirm
                    "
                    class="mx-2"
                    @click="exportReturnQuotation()"
                    v-if="
                      editedQuotation.Type === quotationType.TypeReturnCar &&
                        editedQuotation.IsConfirmQuotation
                    "
                  >
                    {{ $t('quotation_throw_return') }}
                  </v-btn>
                  <!-- 簽核前顯示預覽按鈕，簽核後切換為正式匯出按鈕 -->
                  <v-btn
                    color="warning"
                    :disabled="editedQuotation.IsInvalid || editedQuotationIndex === -1"
                    class="mx-2"
                    @click="exportMoveQuotation(true)"
                    v-if="
                      editedQuotation.Type === quotationType.TypeMove &&
                        !editedQuotation.IsConfirmQuotation
                    "
                  >
                    預覽移機報價單
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotation.IsInvalid ||
                        editedQuotationIndex === -1 ||
                        editedQuotation.IsConfirm
                    "
                    class="mx-2"
                    @click="exportMoveQuotation()"
                    v-if="
                      editedQuotation.Type === quotationType.TypeMove &&
                        editedQuotation.IsConfirmQuotation
                    "
                  >
                    匯出移機報價單
                  </v-btn>
                  <!-- 簽核前顯示預覽按鈕，簽核後切換為正式匯出按鈕 -->
                  <v-btn
                    color="warning"
                    :disabled="editedQuotation.IsInvalid || editedQuotationIndex === -1"
                    class="mx-2"
                    @click="exportTryInstallQuotation(true)"
                    v-if="
                      editedQuotation.Type === quotationType.TypeTryInstall &&
                        !editedQuotation.IsConfirmQuotation
                    "
                  >
                    預覽試裝單
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotation.IsInvalid ||
                        editedQuotationIndex === -1 ||
                        editedQuotation.IsConfirm
                    "
                    class="mx-2"
                    @click="exportTryInstallQuotation()"
                    v-if="
                      editedQuotation.Type === quotationType.TypeTryInstall &&
                        editedQuotation.IsConfirmQuotation
                    "
                  >
                    匯出試裝單
                  </v-btn>

                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotation.IsConfirm ||
                        editedQuotation.IsInvalid ||
                        !editedQuotation.IsExportQuotation ||
                        isLoadingQuotation ||
                        editedQuotationIndex === -1
                    "
                    @click="isConfirmBtn"
                    class="mx-2"
                    v-if="editedQuotation.Type !== quotationType.TypeRenew"
                  >
                    {{ $t('quotation_tool_is_confirm') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      !editedQuotation.IsConfirm ||
                        editedQuotation.IsInvalid ||
                        editedQuotation.IsThrowTransferOrder ||
                        isLoadingQuotation ||
                        editedQuotationIndex === -1
                    "
                    @click="isThrowTransferOrderBtn"
                    class="mx-2"
                    v-if="editedQuotation.Type === quotationType.TypeNewInstall"
                  >
                    轉拋倉管核對
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      !editedQuotation.IsConfirmQuotation ||
                        editedQuotation.IsInvalid ||
                        editedQuotationIndex === -1 ||
                        editedQuotation.IsThrow
                    "
                    class="mx-2"
                    v-if="editedQuotation.Type === quotationType.TypeRenew"
                    @click="renewMonth"
                  >
                    續約月租
                  </v-btn>
                  <input type="file" ref="file" style="display: none" @change="uploadQuotation" />
                  <v-btn
                    fab
                    text
                    small
                    color="primary"
                    :disabled="
                      editedQuotation.IsInvalid ||
                        !editedQuotation.IsConfirm ||
                        editedQuotation.IsDone
                    "
                    @click="openFileDialog"
                    v-if="editedQuotation.Type !== quotationType.TypeRenew"
                  >
                    <v-icon>
                      mdi-paperclip
                    </v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    text
                    small
                    color="primary"
                    :disabled="!editedQuotation.Accessory"
                    @click="downloadUploadFile"
                    v-if="editedQuotation.Type !== quotationType.TypeRenew"
                  >
                    <v-icon>
                      mdi-arrow-down-bold-circle-outline
                    </v-icon>
                  </v-btn>
                  <!--Start 軟體費報價單才有的Btn -->
                  <v-btn
                    color="primary"
                    :disabled="
                      !editedQuotation.IsConfirm ||
                        editedQuotation.IsInvalid ||
                        editedQuotationIndex === -1 ||
                        editedQuotation.IsThrow
                    "
                    class="mx-2"
                    v-if="editedQuotation.Type === quotationType.TypeProjectPayItem"
                    @click="openSelectTypeDialog"
                  >
                    費用轉拋到銷貨單
                  </v-btn>
                  <!--End 軟體費報價單才有的Btn -->
                  <!--Start 補單報價單才有的Btn -->
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotationIndex === -1 ||
                        editedQuotation.IsInvalid ||
                        !editedQuotation.IsConfirm ||
                        editedQuotation.IsThrow
                    "
                    class="mx-2"
                    @click="transferToSale"
                    v-if="
                      editedQuotation.Type === quotationType.TypeOffset &&
                        editedQuotation.SaleNumber
                    "
                  >
                    拋轉品項金額&費用到銷貨單
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotationIndex === -1 ||
                        editedQuotation.IsInvalid ||
                        !editedQuotation.IsConfirm ||
                        editedQuotation.IsThrowToResume
                    "
                    class="mx-2"
                    @click="transferToResume"
                    v-if="editedQuotation.Type === quotationType.TypeOffset"
                  >
                    拋轉履歷卡
                  </v-btn>
                  <!--End 補單報價單才有的Btn -->
                  <!--Start 維修報價單才有的Btn -->
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotationIndex === -1 ||
                        editedQuotation.IsInvalid ||
                        !editedQuotation.IsConfirm ||
                        editedQuotation.IsThrow
                    "
                    class="mx-2"
                    @click="transferToSale"
                    v-if="
                      editedQuotation.Type === quotationType.TypeRepair &&
                        (editedQuotation.NumberType === numberType.Repair ||
                          editedQuotation.NumberType === numberType.Acceptance) &&
                        editedQuotation.PayItems.length > 0
                    "
                  >
                    拋轉費用到銷貨單
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotationIndex === -1 ||
                        editedQuotation.IsInvalid ||
                        !editedQuotation.IsConfirm ||
                        editedQuotation.IsThrow
                    "
                    class="mx-2"
                    @click="throwQuotation"
                    v-if="
                      editedQuotation.Type === quotationType.TypeRepair &&
                        editedQuotation.OffsetItems.length > 0 &&
                        (editedQuotation.NumberType === numberType.Fix ||
                          !editedQuotation.NumberType)
                    "
                  >
                    維修報價單轉拋叫修單
                  </v-btn>
                  <!--End 維修報價單才有的Btn -->
                  <!--Start 新裝報價單才有的Btn -->
                  <v-btn
                    color="primary"
                    class="mx-2"
                    :disabled="
                      editedQuotationIndex === -1 ||
                        editedQuotation.IsInvalid ||
                        !editedQuotation.IsThrowTransferOrder ||
                        !isDoneTransferOrderNumberStatus ||
                        editedQuotation.IsThrow
                    "
                    @click="throwQuotation"
                    v-if="
                      !isShowThrowSaleBtn &&
                        (editedQuotation.Type === quotationType.TypeNewInstall ||
                          editedQuotation.Type === quotationType.TypeTryInstall)
                    "
                  >
                    轉拋安裝通知單
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="mx-2"
                    :disabled="
                      editedQuotationIndex === -1 ||
                        editedQuotation.IsInvalid ||
                        !editedQuotation.IsConfirm ||
                        editedQuotation.IsThrow
                    "
                    @click="throwTryInstallNewInstallToSale"
                    v-if="isShowThrowSaleBtn"
                  >
                    轉拋銷貨單
                  </v-btn>
                  <!--End 新裝報價單才有的Btn -->
                  <!--Start 拆機報價單才有的Btn -->
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotationIndex === -1 ||
                        editedQuotation.IsInvalid ||
                        !editedQuotation.IsConfirm ||
                        editedQuotation.IsThrow
                    "
                    class="mx-2"
                    @click="throwQuotation"
                    v-if="editedQuotation.Type === quotationType.TypeRemoveCar"
                  >
                    {{ $t('quotation_tool_remove_is_throw') }}
                  </v-btn>
                  <!--End 拆機報價單才有的Btn -->
                  <!--Start 回裝報價單才有的Btn -->
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotationIndex === -1 ||
                        editedQuotation.IsInvalid ||
                        !editedQuotation.IsConfirm ||
                        editedQuotation.IsThrow
                    "
                    class="mx-2"
                    @click="throwQuotation"
                    v-if="editedQuotation.Type === quotationType.TypeReturnCar"
                  >
                    {{ $t('quotation_throw_return_notice') }}
                  </v-btn>
                  <!--End 回裝報價單才有的Btn -->
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotationIndex === -1 ||
                        editedQuotation.IsInvalid ||
                        !editedQuotation.IsConfirm ||
                        editedQuotation.IsThrow
                    "
                    class="mx-2"
                    @click="throwQuotation"
                    v-if="editedQuotation.Type === quotationType.TypeMove"
                  >
                    轉拋安裝通知單&叫修單
                  </v-btn>

                  <!--Start 月租報價單才有的Btn -->
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotationIndex === -1 ||
                        editedQuotation.IsInvalid ||
                        !editedQuotation.IsConfirm ||
                        editedQuotation.IsThrowMonth
                    "
                    class="mx-2"
                    @click="throwMonth"
                    v-if="editedQuotation.Type === quotationType.TypeMonth"
                  >
                    拋轉月租
                  </v-btn>
                  <!--End 月租報價單才有的Btn -->
                  <!--Start 專案報價單才有的Btn -->
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotationIndex === -1 ||
                        editedQuotation.IsInvalid ||
                        !editedQuotation.IsConfirm ||
                        editedQuotation.IsThrow
                    "
                    class="mx-2"
                    @click="openSelectTypeDialog"
                    v-if="editedQuotation.Type === quotationType.TypeProject"
                  >
                    拋轉
                  </v-btn>
                  <v-dialog v-model="isShowSelectTypeDialog" persistent max-width="800">
                    <v-card>
                      <v-card-title v-if="!editedQuotation.Customer.Number"
                        >請填寫客戶資訊</v-card-title
                      >
                      <v-card-title v-else></v-card-title>
                      <v-card-text>
                        <ValidationObserver ref="selectTypeDialog">
                          <v-row v-if="editedQuotation.Type === quotationType.TypeProject">
                            <v-col>
                              <ValidationProvider
                                :name="$t('quotation_name')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-select
                                  :items="typeList"
                                  item-text="Name"
                                  item-value="Type"
                                  v-model="selectedType"
                                  :disabled="isLoadingSelectType"
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_name') }}
                                  </template>
                                </v-select>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <quotation-customer-autocomplete
                                refName="customerAutocomplete"
                                @keyupEnter="focusNextInput"
                                :fatherEditedCustomer="editedCustomer"
                                :editedCustomerIndex="-1"
                                :customerName="'quotation_customer_number'"
                                @setCustomer="setThrowCustomer"
                                :isAllTextFieldDisable="isLoadingSelectType"
                              />
                            </v-col>
                            <v-col>
                              <ValidationProvider
                                :name="$t('quotation_shortname')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedCustomer.ShortName"
                                  :error-messages="errors[0]"
                                  disabled
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_shortname') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col>
                              <ValidationProvider
                                :name="$t('quotation_full_name')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedCustomer.FullName"
                                  :error-messages="errors[0]"
                                  disabled
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_full_name') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-text-field
                                v-model="editedCustomer.Tel"
                                :label="$t('quotation_tel')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="editedCustomer.Fax"
                                :label="$t('quotation_fax')"
                                disabled
                              ></v-text-field>
                            </v-col>

                            <v-col>
                              <v-text-field
                                v-model="editedCustomer.Attribute"
                                :label="$t('quotation_attribute')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="editedCustomer.InvoiceAddress"
                                :label="$t('quotation_invoice_address')"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <ValidationProvider
                                :name="$t('quotation_currency_no')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-autocomplete
                                  v-model="editedCustomer.CurrencyNo"
                                  :items="currencyList"
                                  item-text="Mf002"
                                  item-value="Mf001"
                                  :error-messages="errors[0]"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  @keyup.enter="setCurrencyNoAutocomplete"
                                  ref="currencyNoAutocomplete"
                                  :disabled="isLoadingSelectType"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_currency_no') }}
                                  </template>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col>
                              <ValidationProvider
                                :name="$t('quotation_invoice_type')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-autocomplete
                                  v-model="editedCustomer.InvoiceType"
                                  :items="invoiceList"
                                  item-text="Name"
                                  item-value="Type"
                                  :error-messages="errors[0]"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  @keyup.enter="setInvoiceTypeAutocomplete"
                                  ref="invoiceTypeAutocomplete"
                                  :disabled="isLoadingSelectType"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_invoice_type') }}
                                  </template>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                        </ValidationObserver>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="error"
                          text
                          @click="closeThrowNewQuotationDialog"
                          :disabled="isLoadingSelectType"
                        >
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn
                          color="success"
                          text
                          @click="confirmThrowQuotation"
                          :loading="isLoadingSelectType"
                        >
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <!--End 專案報價單才有的Btn -->
                  <v-btn
                    fab
                    small
                    @click="isAllTextFieldDisabled = false"
                    :disabled="
                      isLoadingSaveBtn ||
                        editedQuotation.IsInvalid ||
                        editedQuotation.IsConfirmQuotation ||
                        editedQuotationIndex === -1 ||
                        !isAllTextFieldDisabled
                    "
                    class="mx-2 primary"
                  >
                    <v-icon>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    small
                    @click="isShowDeleteQuotationDialog = true"
                    :disabled="
                      isLoadingSaveBtn ||
                        editedQuotation.IsInvalid ||
                        editedQuotation.IsConfirmQuotation ||
                        editedQuotationIndex === -1 ||
                        !isAllTextFieldDisabled
                    "
                    class="mx-2 error"
                  >
                    <v-icon>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    small
                    class="mx-2"
                    color="green darken-1"
                    text
                    @click="saveEditedQuotation"
                    :loading="isLoadingSaveBtn"
                    :disabled="isAllTextFieldDisabled"
                  >
                    <v-icon>
                      mdi-content-save
                    </v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    text
                    small
                    @click="cancelEditBtn"
                    :disabled="isAllTextFieldDisabled"
                    v-if="editedQuotationIndex !== -1"
                    class="mx-2"
                    color="red darken-1"
                  >
                    <v-icon>
                      mdi-replay
                    </v-icon>
                  </v-btn>
                  <v-tooltip bottom :disabled="!isCopyLockedByLegacyDate">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-on="isCopyLockedByLegacyDate ? on : null" v-bind="attrs">
                        <v-btn
                          fab
                          text
                          small
                          color="primary"
                          :disabled="
                            editedQuotationIndex === -1 ||
                              !isAllTextFieldDisabled ||
                              isCopyLockedByLegacyDate
                          "
                          @click="copyQuotation"
                          v-if="
                            editedQuotation.Type !== quotationType.TypeOffset &&
                              (editedQuotation.Type !== quotationType.TypeRepair ||
                                !editedQuotation.NumberType)
                          "
                        >
                          <v-icon>
                            mdi-content-copy
                          </v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span>{{ $t('copy_disabled_message') }}</span>
                  </v-tooltip>
                  <v-btn
                    class="ml-2"
                    color="error"
                    :disabled="
                      editedQuotationIndex === -1 ||
                        (isRoleManagerOrAdmin && !editedQuotation.IsConfirmQuotation) ||
                        (!isRoleManagerOrAdmin && !editedQuotation.IsConfirm) ||
                        editedQuotation.IsThrow ||
                        editedQuotation.IsInvalid
                    "
                    @click="isShowInvalidQuotationDialogBtn"
                  >
                    {{ $t('quotation_invalid_quotation') }}
                  </v-btn>
                  <not-invalid-btn
                    :editedQuotation="editedQuotation"
                    :isAllTextFieldDisabled="isAllTextFieldDisabled"
                    @searchEditQuotation="searchEditQuotation"
                    v-if="editedQuotation.IsInvalid && isRoleManagerOrAdmin"
                  />
                  <v-dialog v-model="isShowInvalidQuotationDialog" persistent max-width="600px">
                    <v-card>
                      <v-card-title>確定要作廢?</v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <ValidationObserver ref="invalidQuotation">
                              <ValidationProvider
                                name="作廢原因"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-textarea
                                  outlined
                                  v-model="invalidReason"
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    作廢原因
                                  </template>
                                </v-textarea>
                              </ValidationProvider>
                            </ValidationObserver>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" text @click="closeInvalidQuotationDialog">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="success" text @click="invalidQuotation">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-spacer></v-spacer>
                  <div
                    style="color:red; margin-right:100px"
                    v-if="
                      editedQuotationIndex !== -1 &&
                        (!editedQuotation.IsConfirmQuotation || editedQuotation.IsInvalid)
                    "
                  >
                    <v-icon color="error">
                      mdi-alert-box
                    </v-icon>
                    {{ methodsStatus(editedQuotation) }}
                  </div>
                  <div
                    style="color:green; margin-right:100px"
                    v-else-if="editedQuotationIndex !== -1"
                  >
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ methodsStatus(editedQuotation) }}
                  </div>
                </v-row>
              </v-card-text>
              <v-card-text>
                <v-dialog v-model="isUploadDialog">
                  <v-card>
                    <v-card-title>
                      {{ $t('quotation_remark_accessory_title') }}
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col>
                          <v-textarea solo v-model="uploadRecord.AccessoryRemark"></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="saveUploadDialogRemark">
                        {{ $t('common_confirm') }}
                      </v-btn>
                      <v-btn color="primary" text @click="closeUploadDialog">
                        {{ $t('common_cancel') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card-text>
              <v-tabs>
                <v-tab href="#tab-1">{{ $t('quotation_tab_first') }}</v-tab>
                <v-tab href="#tab-2">條款</v-tab>
                <v-tab
                  href="#tab-3"
                  v-if="
                    editedQuotation.Type === quotationType.TypeNewInstall ||
                      editedQuotation.Type === quotationType.TypeReturnCar ||
                      editedQuotation.Type === quotationType.TypeProject
                  "
                  >{{ $t('quotation_tab_third') }}</v-tab
                >
                <v-tab-item value="tab-1">
                  <v-card flat>
                    <v-card-text>
                      <v-container>
                        <ValidationObserver ref="dialog">
                          <v-row>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('quotation_name')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-autocomplete
                                  v-model="editedQuotation.Type"
                                  :items="computedType"
                                  item-text="Name"
                                  item-value="Type"
                                  :error-messages="errors[0]"
                                  :disabled="
                                    editedQuotationIndex !== -1 || isAllTextFieldDisabled || isCopy
                                  "
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :loading="isLoadingQuotation"
                                  @keyup.enter="setTypeAutocomplete"
                                  ref="typeAutocomplete"
                                  return-object
                                  @change="setQuotationName"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_name') }}
                                  </template>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('quotation_number')"
                                :rules="{ required: true }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.Number"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_number') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('quotation_subject')"
                                :rules="{ required: true, max: 20 }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.Subject"
                                  :disabled="isAllTextFieldDisabled"
                                  :error-messages="errors[0]"
                                  @keyup.enter="focusNextInput"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_subject') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedQuotation.CopyNumber"
                                label="複製前置單號"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.Type !== quotationType.TypeProjectPayItem"
                            >
                              <v-text-field
                                v-model="editedQuotation.Brand"
                                :disabled="isAllTextFieldDisabled"
                                @keyup.enter="focusNextInput"
                                label="廠牌/車型"
                              >
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('quotation_create_time')"
                                :rules="{ required: true }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="computeCreateTime"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_create_time') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.Type === quotationType.TypeTryInstall"
                            >
                              <date-picker-exp-date
                                :dateName="'quotation_try_install_date'"
                                :isAllTextFieldDisabled="isAllTextFieldDisabled"
                                :createTime="editedQuotation.CreateTime"
                                :expDate="editedQuotation.TryInstallTime"
                                @setDate="setTryInstallTime"
                                @keyupEnter="focusNextInput"
                                v-if="!editedQuotation.IsConfirmQuotation"
                              />
                              <ValidationProvider
                                :name="$t('quotation_try_install_date')"
                                :rules="{ required: true }"
                                v-slot="{ errors }"
                                v-else
                              >
                                <v-text-field
                                  v-model="computeTryInstallTime"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_try_install_date') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3" v-else>
                              <date-picker-exp-date
                                :dateName="'quotation_exp_date'"
                                :isAllTextFieldDisabled="isAllTextFieldDisabled"
                                :createTime="editedQuotation.CreateTime"
                                :expDate="editedQuotation.ExpDate"
                                @setDate="setExpDate"
                                @keyupEnter="focusNextInput"
                                v-if="!editedQuotation.IsConfirmQuotation"
                              />
                              <ValidationProvider
                                :name="$t('quotation_exp_date')"
                                :rules="{ required: true }"
                                v-slot="{ errors }"
                                v-else
                              >
                                <v-text-field
                                  v-model="computeExpDate"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_exp_date') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-autocomplete
                                :items="allSpecialNeedList"
                                item-text="Name"
                                item-value="Name"
                                :label="$t('quotation_special_need')"
                                :disabled="isAllTextFieldDisabled"
                                v-model="editedQuotation.SpecialNeedList"
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_results')"
                                v-if="
                                  editedQuotation.Type === quotationType.TypeNewInstall ||
                                    editedQuotation.Type === quotationType.TypeReturnCar ||
                                    editedQuotation.Type === quotationType.TypeMove ||
                                    editedQuotation.Type === quotationType.TypeProject ||
                                    editedQuotation.Type === quotationType.TypeTryInstall
                                "
                                small-chips
                                multiple
                                return-object
                                @keydown.enter="setKeyDownAutocomplete"
                                @keyup.enter="setKeyUpAutocomplete"
                                ref="specialNeedAutocomplete"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-card
                              min-width="100%"
                              elevation="1"
                              v-if="
                                editedQuotation.Type === quotationType.TypeReturnCar ||
                                  editedQuotation.Type === quotationType.TypeMove ||
                                  editedQuotation.Type === quotationType.TypeRenew
                              "
                            >
                              <v-card-title>
                                拆機客戶
                              </v-card-title>
                              <v-card-text>
                                <v-row>
                                  <v-col cols="3">
                                    <quotation-customer-autocomplete
                                      refName="customerAutocomplete"
                                      @keyupEnter="focusNextInput"
                                      :fatherEditedCustomer="editedQuotation.OriginalCustomer"
                                      :editedCustomerIndex="-1"
                                      :customerName="'quotation_customer_number'"
                                      @setCustomer="setOriginalCustomer"
                                      :isAllTextFieldDisable="isAllTextFieldDisabled"
                                    />
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_shortname')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-text-field
                                        v-model="editedQuotation.OriginalCustomer.ShortName"
                                        :error-messages="errors[0]"
                                        disabled
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_shortname') }}
                                        </template>
                                      </v-text-field>
                                    </ValidationProvider>
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_full_name')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-text-field
                                        v-model="editedQuotation.OriginalCustomer.FullName"
                                        :error-messages="errors[0]"
                                        disabled
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_full_name') }}
                                        </template>
                                      </v-text-field>
                                    </ValidationProvider>
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_original_license_plate')"
                                      :rules="{ max: 13 }"
                                      v-slot="{ errors }"
                                      v-if="
                                        editedQuotation.Type === quotationType.TypeReturnCar ||
                                          editedQuotation.Type === quotationType.TypeMove
                                      "
                                    >
                                      <v-combobox
                                        :items="customerOriginalLicensePlateList"
                                        item-text="LicensePlate"
                                        item-value="LicensePlate"
                                        v-model.trim="editedQuotation.OriginalLicensePlate"
                                        :loading-text="$t('common_get_data')"
                                        :no-data-text="$t('common_no_results')"
                                        :label="$t('quotation_original_license_plate')"
                                        :disabled="isAllTextFieldDisabled"
                                        @change="searchResumeMonthForOriginalLicensePlate"
                                        :error-messages="errors[0]"
                                        @click="getCustomerOriginalLicenseLicensePlateList"
                                      >
                                        <template v-slot:item="data">
                                          <template>
                                            <v-list-item-content>
                                              <v-list-item-title>
                                                {{ data.item.LicensePlate }}
                                              </v-list-item-title>
                                              <v-list-item-subtitle>
                                                {{ $t('quotation_shortname') }} :
                                                {{ data.item.CustomerShortName }}
                                              </v-list-item-subtitle>
                                              <v-list-item-subtitle>
                                                {{ $t('quotation_full_name') }} :
                                                {{ data.item.CustomerFullName }}
                                              </v-list-item-subtitle>
                                            </v-list-item-content>
                                          </template>
                                        </template>
                                      </v-combobox>
                                    </ValidationProvider>
                                    <ValidationProvider
                                      :name="$t('quotation_original_license_plate')"
                                      :rules="{ max: 13 }"
                                      v-slot="{ errors }"
                                      v-else-if="editedQuotation.Type === quotationType.TypeRenew"
                                    >
                                      <v-autocomplete
                                        :items="customerOriginalLicensePlateList"
                                        item-text="LicensePlate"
                                        item-value="LicensePlate"
                                        v-model.trim="editedQuotation.OriginalLicensePlate"
                                        :loading-text="$t('common_get_data')"
                                        :no-data-text="$t('common_no_results')"
                                        :label="$t('quotation_original_license_plate')"
                                        :disabled="isAllTextFieldDisabled"
                                        @change="searchMonthForOriginalLicensePlate"
                                        :error-messages="errors[0]"
                                        @click="getCustomerOriginalLicenseLicensePlateList"
                                      >
                                        <template v-slot:item="data">
                                          <template>
                                            <v-list-item-content>
                                              <v-list-item-title>
                                                {{ data.item.LicensePlate }}
                                              </v-list-item-title>
                                              <v-list-item-subtitle>
                                                {{ $t('quotation_shortname') }} :
                                                {{ data.item.CustomerName }}
                                              </v-list-item-subtitle>
                                              <v-list-item-subtitle>
                                                {{ $t('quotation_full_name') }} :
                                                {{ data.item.CustomerFullName }}
                                              </v-list-item-subtitle>
                                            </v-list-item-content>
                                          </template>
                                        </template>
                                      </v-autocomplete>
                                    </ValidationProvider>
                                  </v-col>
                                </v-row>
                                <v-row v-if="editedQuotation.Type === quotationType.TypeMove">
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.OriginalCustomer.Tel"
                                      :label="$t('quotation_tel')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.OriginalCustomer.Fax"
                                      :label="$t('quotation_fax')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>

                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.OriginalCustomer.Attribute"
                                      :label="$t('quotation_attribute')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.OriginalCustomer.InvoiceAddress"
                                      :label="$t('quotation_invoice_address')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row v-if="editedQuotation.Type === quotationType.TypeMove">
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_currency_no')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-autocomplete
                                        v-model="editedQuotation.OriginalCustomer.CurrencyNo"
                                        :items="currencyList"
                                        item-text="Mf002"
                                        item-value="Mf001"
                                        :disabled="isAllTextFieldDisabled"
                                        :error-messages="errors[0]"
                                        :loading-text="$t('common_get_data')"
                                        :no-data-text="$t('common_no_results')"
                                        @keyup.enter="setCurrencyNoAutocomplete"
                                        ref="currencyNoAutocomplete"
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_currency_no') }}
                                        </template>
                                      </v-autocomplete>
                                    </ValidationProvider>
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_invoice_type')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-autocomplete
                                        v-model="editedQuotation.OriginalCustomer.InvoiceType"
                                        :items="invoiceList"
                                        item-text="Name"
                                        item-value="Type"
                                        :disabled="isAllTextFieldDisabled"
                                        :error-messages="errors[0]"
                                        :loading-text="$t('common_get_data')"
                                        :no-data-text="$t('common_no_results')"
                                        @keyup.enter="setInvoiceTypeAutocomplete"
                                        ref="invoiceTypeAutocomplete"
                                        @change="computedAmt"
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_invoice_type') }}
                                        </template>
                                      </v-autocomplete>
                                    </ValidationProvider>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-row>
                          <v-row
                            v-if="
                              editedQuotation.Type !== quotationType.TypeProject &&
                                editedQuotation.Type !== quotationType.TypeProjectPayItem
                            "
                          >
                            <v-card
                              min-width="100%"
                              elevation="1"
                              :class="
                                editedQuotation.Type === quotationType.TypeReturnCar ||
                                editedQuotation.Type === quotationType.TypeMove ||
                                editedQuotation.Type === quotationType.TypeRenew
                                  ? 'my-5'
                                  : 'mb-5'
                              "
                            >
                              <v-card-title
                                v-if="
                                  editedQuotation.Type === quotationType.TypeReturnCar ||
                                    editedQuotation.Type === quotationType.TypeMove ||
                                    editedQuotation.Type === quotationType.TypeRenew
                                "
                              >
                                回裝客戶
                              </v-card-title>
                              <v-card-title v-else>
                                客戶資料
                              </v-card-title>
                              <v-card-text>
                                <v-row>
                                  <v-col cols="3">
                                    <quotation-customer-autocomplete
                                      refName="customerAutocomplete"
                                      @keyupEnter="focusNextInput"
                                      :fatherEditedCustomer="editedQuotation.Customer"
                                      :editedCustomerIndex="-1"
                                      :customerName="'quotation_customer_number'"
                                      @setCustomer="setCustomer"
                                      :isAllTextFieldDisable="isAllTextFieldDisabled"
                                    />
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_shortname')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-text-field
                                        v-model="editedQuotation.Customer.ShortName"
                                        :error-messages="errors[0]"
                                        disabled
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_shortname') }}
                                        </template>
                                      </v-text-field>
                                    </ValidationProvider>
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_full_name')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-text-field
                                        v-model="editedQuotation.Customer.FullName"
                                        :error-messages="errors[0]"
                                        disabled
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_full_name') }}
                                        </template>
                                      </v-text-field>
                                    </ValidationProvider>
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_license_plate')"
                                      :rules="{ max: 13 }"
                                      v-slot="{ errors }"
                                      v-if="
                                        editedQuotation.Type === quotationType.TypeRemoveCar ||
                                          editedQuotation.Type === quotationType.TypeReturnCar ||
                                          editedQuotation.Type === quotationType.TypeRepair ||
                                          editedQuotation.Type === quotationType.TypeOffset ||
                                          editedQuotation.Type === quotationType.TypeMove
                                      "
                                    >
                                      <v-combobox
                                        :items="customerLicensePlateList"
                                        item-text="LicensePlate"
                                        item-value="LicensePlate"
                                        v-model.trim="editedQuotation.LicensePlate"
                                        :loading-text="$t('common_get_data')"
                                        :no-data-text="$t('common_no_results')"
                                        :label="$t('quotation_license_plate')"
                                        :disabled="isAllTextFieldDisabled"
                                        :error-messages="errors[0]"
                                        :return-object="false"
                                        @change="searchResumeMonthForLicensePlate"
                                        @click="getCustomerLicensePlateList"
                                      >
                                        <template v-slot:item="data">
                                          <template>
                                            <v-list-item-content>
                                              <v-list-item-title>
                                                {{ data.item.LicensePlate }}
                                              </v-list-item-title>
                                              <v-list-item-subtitle>
                                                {{ $t('quotation_shortname') }} :
                                                {{ data.item.CustomerShortName }}
                                              </v-list-item-subtitle>
                                              <v-list-item-subtitle>
                                                {{ $t('quotation_full_name') }} :
                                                {{ data.item.CustomerFullName }}
                                              </v-list-item-subtitle>
                                            </v-list-item-content>
                                          </template>
                                        </template>
                                      </v-combobox>
                                    </ValidationProvider>
                                    <ValidationProvider
                                      :name="$t('quotation_license_plate')"
                                      :rules="{ max: 13 }"
                                      v-slot="{ errors }"
                                      v-if="editedQuotation.Type === quotationType.TypeRenew"
                                    >
                                      <v-autocomplete
                                        :items="customerLicensePlateList"
                                        item-text="LicensePlate"
                                        item-value="LicensePlate"
                                        v-model.trim="editedQuotation.LicensePlateList"
                                        :loading-text="$t('common_get_data')"
                                        :no-data-text="$t('common_no_results')"
                                        :label="$t('quotation_license_plate')"
                                        :disabled="isAllTextFieldDisabled"
                                        :error-messages="errors[0]"
                                        @change="searchMonthForLicensePlate"
                                        @click="getCustomerLicensePlateList"
                                        small-chips
                                        multiple
                                      >
                                        <template v-slot:item="data">
                                          <template>
                                            <v-list-item-content>
                                              <v-list-item-title>
                                                {{ data.item.LicensePlate }}
                                              </v-list-item-title>
                                              <v-list-item-subtitle>
                                                {{ $t('quotation_shortname') }} :
                                                {{ data.item.CustomerName }}
                                              </v-list-item-subtitle>
                                              <v-list-item-subtitle>
                                                {{ $t('quotation_full_name') }} :
                                                {{ data.item.CustomerFullName }}
                                              </v-list-item-subtitle>
                                            </v-list-item-content>
                                          </template>
                                        </template>
                                      </v-autocomplete>
                                    </ValidationProvider>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.Customer.Tel"
                                      :label="$t('quotation_tel')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.Customer.Fax"
                                      :label="$t('quotation_fax')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.Customer.Attribute"
                                      :label="$t('quotation_attribute')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.Customer.InvoiceAddress"
                                      :label="$t('quotation_invoice_address')"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_currency_no')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-autocomplete
                                        v-model="editedQuotation.Customer.CurrencyNo"
                                        :items="currencyList"
                                        item-text="Mf002"
                                        item-value="Mf001"
                                        :disabled="isAllTextFieldDisabled"
                                        :error-messages="errors[0]"
                                        :loading-text="$t('common_get_data')"
                                        :no-data-text="$t('common_no_results')"
                                        @keyup.enter="setCurrencyNoAutocomplete"
                                        ref="currencyNoAutocomplete"
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_currency_no') }}
                                        </template>
                                      </v-autocomplete>
                                    </ValidationProvider>
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_invoice_type')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-autocomplete
                                        v-model="editedQuotation.Customer.InvoiceType"
                                        :items="invoiceList"
                                        item-text="Name"
                                        item-value="Type"
                                        :disabled="isAllTextFieldDisabled"
                                        :error-messages="errors[0]"
                                        :loading-text="$t('common_get_data')"
                                        :no-data-text="$t('common_no_results')"
                                        @keyup.enter="setInvoiceTypeAutocomplete"
                                        ref="invoiceTypeAutocomplete"
                                        @change="computedAmt"
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_invoice_type') }}
                                        </template>
                                      </v-autocomplete>
                                    </ValidationProvider>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-row>
                          <v-row v-else>
                            <v-card min-width="100%" elevation="1" class="mb-5">
                              <v-card-title>客戶資料</v-card-title>
                              <v-card-text>
                                <v-row>
                                  <v-col cols="3">
                                    <quotation-customer-combobox
                                      refName="customerAutocomplete"
                                      @keyupEnter="focusNextInput"
                                      :fatherEditedCustomer="editedQuotation.Customer"
                                      :editedCustomerIndex="-1"
                                      :customerName="'quotation_shortname'"
                                      @setCustomer="setCustomer"
                                      :isAllTextFieldDisable="isAllTextFieldDisabled"
                                    />
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_full_name')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-text-field
                                        v-model="editedQuotation.Customer.FullName"
                                        :error-messages="errors[0]"
                                        :disabled="!isNeedFullName || isAllTextFieldDisabled"
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_full_name') }}
                                        </template>
                                      </v-text-field>
                                    </ValidationProvider>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.Customer.Number"
                                      :label="$t('quotation_customer_number')"
                                      disabled
                                    >
                                    </v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.Customer.Tel"
                                      :label="$t('quotation_tel')"
                                      :disabled="isAllTextFieldDisabled"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.Customer.Fax"
                                      :label="$t('quotation_fax')"
                                      :disabled="isAllTextFieldDisabled"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.Customer.Attribute"
                                      :label="$t('quotation_attribute')"
                                      :disabled="isAllTextFieldDisabled"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.Customer.InvoiceAddress"
                                      :label="$t('quotation_invoice_address')"
                                      :disabled="isAllTextFieldDisabled"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_currency_no')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-autocomplete
                                        v-model="editedQuotation.Customer.CurrencyNo"
                                        :items="currencyList"
                                        item-text="Mf002"
                                        item-value="Mf001"
                                        :disabled="isAllTextFieldDisabled"
                                        :error-messages="errors[0]"
                                        :loading-text="$t('common_get_data')"
                                        :no-data-text="$t('common_no_results')"
                                        @keyup.enter="setCurrencyNoAutocomplete"
                                        ref="currencyNoAutocomplete"
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_currency_no') }}
                                        </template>
                                      </v-autocomplete>
                                    </ValidationProvider>
                                  </v-col>
                                  <v-col cols="3">
                                    <ValidationProvider
                                      :name="$t('quotation_invoice_type')"
                                      rules="required"
                                      v-slot="{ errors }"
                                    >
                                      <v-autocomplete
                                        v-model="editedQuotation.Customer.InvoiceType"
                                        :items="invoiceList"
                                        item-text="Name"
                                        item-value="Type"
                                        :disabled="isAllTextFieldDisabled"
                                        :error-messages="errors[0]"
                                        :loading-text="$t('common_get_data')"
                                        :no-data-text="$t('common_no_results')"
                                        @keyup.enter="setInvoiceTypeAutocomplete"
                                        ref="invoiceTypeAutocomplete"
                                        @change="computedAmt"
                                      >
                                        <template v-slot:label>
                                          <span class="red--text">
                                            <strong>* </strong>
                                          </span>
                                          {{ $t('quotation_invoice_type') }}
                                        </template>
                                      </v-autocomplete>
                                    </ValidationProvider>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-row>
                          <v-row v-if="editedQuotation.Type === quotationType.TypeRepair">
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-autocomplete
                                :items="numberTypeList"
                                item-text="Name"
                                item-value="Type"
                                :label="$t('engineer_number_type')"
                                :disabled="isAllTextFieldDisabled"
                                v-model="editedQuotation.NumberType"
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_results')"
                                @keyupEnter="focusNextInput"
                                @change="setNumber"
                              ></v-autocomplete>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.NumberType === numberType.Acceptance"
                            >
                              <acceptance-number-autocomplete
                                :editedQuotationIndex="editedQuotationIndex"
                                :isAllTextFieldDisable="isAllTextFieldDisabled"
                                refName="acceptanceNumberAutocomplete"
                                :fatherAcceptanceNumber="editedQuotation.AcceptanceNumber"
                                :customerId="editedQuotation.Customer.Id"
                                :licensePlate="editedQuotation.LicensePlate"
                                @setAcceptanceNumber="setAcceptanceNumber"
                                @keyupEnter="focusNextInput"
                                v-if="
                                  !isAllTextFieldDisabled && !editedQuotation.IsConfirmQuotation
                                "
                              />
                              <ValidationProvider
                                :name="$t('serialnumber_acceptance_number')"
                                rules="required"
                                v-slot="{ errors }"
                                v-else
                              >
                                <v-text-field
                                  v-model="editedQuotation.AcceptanceNumber"
                                  :error-messages="errors[0]"
                                  disabled
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('serialnumber_acceptance_number') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.NumberType === numberType.Fix"
                            >
                              <fix-number-autocomplete
                                :editedQuotationIndex="editedQuotationIndex"
                                :isAllTextFieldDisable="isAllTextFieldDisabled"
                                refName="fixNumberAutocomplete"
                                :fatherFixNumber="editedQuotation.FixNumber"
                                :customerId="editedQuotation.Customer.Id"
                                :licensePlate="editedQuotation.LicensePlate"
                                @setFixNumber="setFixNumber"
                                @keyupEnter="focusNextInput"
                                v-if="
                                  !isAllTextFieldDisabled && !editedQuotation.IsConfirmQuotation
                                "
                              />
                              <ValidationProvider
                                :name="$t('fix_number')"
                                rules="required"
                                v-slot="{ errors }"
                                v-else
                              >
                                <v-text-field
                                  v-model="editedQuotation.FixNumber"
                                  :error-messages="errors[0]"
                                  disabled
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('fix_number') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.NumberType === numberType.Repair"
                            >
                              <repair-number-autocomplete
                                :editedQuotationIndex="editedQuotationIndex"
                                :isAllTextFieldDisable="isAllTextFieldDisabled"
                                refName="repairNumberAutocomplete"
                                :fatherRepairNumber="editedQuotation.RepairNumber"
                                :customerId="editedQuotation.Customer.Id"
                                :licensePlate="editedQuotation.LicensePlate"
                                @setRepairNumber="setRepairNumber"
                                @keyupEnter="focusNextInput"
                                v-if="
                                  !isAllTextFieldDisabled && !editedQuotation.IsConfirmQuotation
                                "
                              />
                              <ValidationProvider
                                :name="$t('serialnumber_repair_number')"
                                rules="required"
                                v-slot="{ errors }"
                                v-else
                              >
                                <v-text-field
                                  v-model="editedQuotation.RepairNumber"
                                  :error-messages="errors[0]"
                                  disabled
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('serialnumber_repair_number') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.SaleType"
                            >
                              <v-text-field
                                v-model="editedQuotation.SaleType"
                                :label="$t('month_sale_item_sale_type')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.SaleNumber"
                            >
                              <v-text-field
                                v-model="editedQuotation.SaleNumber"
                                :label="$t('month_sale_item_sale_number')"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedQuotation.ContactName"
                                :label="$t('quotation_contact_name')"
                                :disabled="isAllTextFieldDisabled"
                                @keyup.enter="focusNextInput"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedQuotation.ContactPhone"
                                :label="$t('quotation_contact_phone')"
                                :disabled="isAllTextFieldDisabled"
                                @keyup.enter="focusNextInput"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.Type !== quotationType.TypeProjectPayItem"
                            >
                              <v-text-field
                                v-model="editedQuotation.CarPlace"
                                :label="$t('quotation_car_place')"
                                :disabled="isAllTextFieldDisabled"
                                @keyup.enter="focusNextInput"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.Type === quotationType.TypeRenew"
                            >
                              <date-picker-set-time
                                :time="editedQuotation.RenewMonthTime"
                                :dateName="'month_quotation_renew_time'"
                                :isAllTextFieldDisabled="isAllTextFieldDisabled"
                                @setDate="setRenewMonthTime"
                                @keyupEnter="focusNextInput"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.Type === quotationType.TypeRemoveCar"
                            >
                              <ValidationProvider
                                :name="$t('quotation_removed_reason')"
                                rules="required"
                                v-slot="{ errors }"
                                v-if="editedQuotation.Type === quotationType.TypeRemoveCar"
                              >
                                <v-autocomplete
                                  v-model="editedQuotation.RemovedReason"
                                  :items="allRemovedReason"
                                  :label="$t('quotation_removed_reason')"
                                  item-text="Name"
                                  item-value="Type"
                                  :disabled="isAllTextFieldDisabled"
                                  :error-messages="errors[0]"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :loading="isLoadingQuotation"
                                  @keyup.enter="setRemovedReasonAutocomplete"
                                  ref="removedReasonAutocomplete"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_removed_reason') }}
                                  </template>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.Type === quotationType.TypeMonth"
                            >
                              <date-picker-set-time
                                :time="editedQuotation.MonthStartTime"
                                :dateName="'month_start_date'"
                                :isAllTextFieldDisabled="isAllTextFieldDisabled"
                                @setDate="setMonthStartTime"
                                @keyupEnter="focusNextInput"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="
                                editedQuotation.Type === quotationType.TypeNewInstall ||
                                  editedQuotation.Type === quotationType.TypeMonth ||
                                  editedQuotation.Type === quotationType.TypeProject ||
                                  editedQuotation.Type === quotationType.TypeTryInstall
                              "
                            >
                              <ValidationProvider
                                :name="$t('quotation_license_plate')"
                                :rules="{ max: 13 }"
                                v-slot="{ errors }"
                              >
                                <v-combobox
                                  v-model.trim="editedQuotation.LicensePlateList"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :label="$t('quotation_license_plate')"
                                  :disabled="isAllTextFieldDisabled"
                                  multiple
                                  small-chips
                                  @change="setCarQuantity"
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:append-outer>
                                    <LicensePlateBatchInputButton
                                      :value="editedQuotation.LicensePlateList"
                                      :disabled="isAllTextFieldDisabled"
                                      @input="onBatchInputLicensePlate"
                                    />
                                  </template>
                                </v-combobox>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="
                                editedQuotation.Type === quotationType.TypeNewInstall ||
                                  editedQuotation.Type === quotationType.TypeProject ||
                                  editedQuotation.Type === quotationType.TypeTryInstall
                              "
                            >
                              <ValidationProvider
                                :name="$t('quotation_car_quantity')"
                                :rules="{
                                  required: true,
                                  regex: /^[0-9]+$/,
                                  min_value: 1,
                                }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.CarQuantity"
                                  :disabled="isAllTextFieldDisabled"
                                  :error-messages="errors[0]"
                                  @keyup.enter="focusNextInput"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_car_quantity') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.Type === quotationType.TypeTryInstall"
                            >
                              <v-autocomplete
                                v-model="editedQuotation.OriginalTryInstallNumber"
                                :items="tryInstallQuotationList"
                                item-text="Number"
                                item-value="Number"
                                label="同一試裝單號"
                                :disabled="
                                  isAllTextFieldDisabled ||
                                    editedQuotation.LicensePlateList.length > 1
                                "
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_results')"
                                @click="getIsConfirmTryInstallQuotations"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row
                            v-if="
                              editedQuotation.Type === quotationType.TypeNewInstall ||
                                editedQuotation.Type === quotationType.TypeReturnCar ||
                                editedQuotation.Type === quotationType.TypeRepair ||
                                editedQuotation.Type === quotationType.TypeOffset ||
                                editedQuotation.Type === quotationType.TypeMove ||
                                editedQuotation.Type === quotationType.TypeProject
                            "
                          >
                            <v-col cols="2" class="blue--text">
                              {{ $t('quotation_item') }}
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                :name="$t('quotation_amt')"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.ItemAmt"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_amt') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                name="折扣"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.ItemDiscount"
                                  :error-messages="errors[0]"
                                  @input="computedAmt"
                                  :disabled="isAllTextFieldDisabled"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    折扣
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                name="折扣後金額"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.ItemDiscountPrice"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    折扣後金額
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                :name="$t('quotation_tax')"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.ItemTax"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_tax') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                :name="$t('quotation_total_amt')"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.ItemTotalAmt"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_total_amt') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row
                            v-if="
                              editedQuotation.Type === quotationType.TypeNewInstall ||
                                editedQuotation.Type === quotationType.TypeReturnCar ||
                                editedQuotation.Type === quotationType.TypeMonth ||
                                editedQuotation.Type === quotationType.TypeMove ||
                                editedQuotation.Type === quotationType.TypeProject ||
                                editedQuotation.Type === quotationType.TypeTryInstall
                            "
                          >
                            <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                              {{ $t('quotation_month_item') }}
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('quotation_amt')"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.MonthAmt"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_amt') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('quotation_tax')"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.MonthTax"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_tax') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('quotation_total_amt')"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.MonthTotalAmt"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_total_amt') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row v-if="editedQuotation.Type !== quotationType.TypeRenew">
                            <v-col cols="2" class="blue--text">
                              {{ $t('quotation_pay_item') }}
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                :name="$t('quotation_amt')"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.PayAmt"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_amt') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                name="折扣"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.PayDiscount"
                                  :error-messages="errors[0]"
                                  @input="computedAmt"
                                  :disabled="isAllTextFieldDisabled"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    折扣
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                name="折扣後金額"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.PayDiscountPrice"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    折扣後金額
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                :name="$t('quotation_tax')"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.PayTax"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_tax') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                :name="$t('quotation_total_amt')"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedQuotation.PayTotalAmt"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_total_amt') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('quotation_select_quotation_terms')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-select
                                  v-model="selectQuotationTerm"
                                  :items="allQuotationTerms"
                                  :disabled="isAllTextFieldDisabled"
                                  item-text="Name"
                                  item-value="Type"
                                  :error-messages="errors[0]"
                                  return-object
                                  @keyup.enter="setTermAutocomplete"
                                  ref="termAutocomplete"
                                  @change="setQuotationTerm"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_select_quotation_terms') }}
                                  </template>
                                </v-select>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.Type !== quotationType.TypeRenew"
                            >
                              <date-picker-sign-date
                                :dateName="'quotation_sign_date'"
                                :isConfirm="editedQuotation.IsConfirm"
                                :isAllTextFieldDisabled="editedQuotation.IsInvalid"
                                :fileDate="fileDate"
                                @setDate="setSignDate"
                                @keyupEnter="focusNextInput"
                                v-if="
                                  editedQuotation.IsExportQuotation &&
                                    !editedQuotation.IsConfirm &&
                                    !editedQuotation.IsInvalid
                                "
                              />
                              <v-text-field v-model="computeSignDate" disabled v-else>
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_sign_date') }}
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedQuotation.CreateBy"
                                :label="$t('quotation_create_by')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="
                                editedQuotation.Type === quotationType.TypeRemoveCar ||
                                  editedQuotation.Type === quotationType.TypeMove
                              "
                            >
                              <date-picker-set-time-not-request
                                :time="editedQuotation.SpecifyStopTime"
                                :dateName="'quotation_specify_stop_time'"
                                :minDate="minDate"
                                :isAllTextFieldDisabled="isAllTextFieldDisabled"
                                @setDate="setSpecifyStopTime"
                                @keyupEnter="focusNextInput"
                              />
                            </v-col>
                          </v-row>
                          <v-row v-if="editedQuotation.Type === quotationType.TypeOffset">
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.OriginalNumber"
                            >
                              <v-text-field
                                v-model="editedQuotation.OriginalNumber"
                                :label="$t('repair_quotation_number')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.SaleType"
                            >
                              <v-text-field
                                v-model="editedQuotation.SaleType"
                                :label="$t('month_sale_item_sale_type')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.SaleNumber"
                            >
                              <v-text-field
                                v-model="editedQuotation.SaleNumber"
                                :label="$t('month_sale_item_sale_number')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.AcceptanceNumber"
                            >
                              <v-text-field
                                v-model="editedQuotation.AcceptanceNumber"
                                :label="$t('serialnumber_acceptance_number')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.RepairNumber"
                            >
                              <v-text-field
                                v-model="editedQuotation.RepairNumber"
                                :label="$t('serialnumber_repair_number')"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="editedQuotation.Type === quotationType.TypeProjectPayItem">
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.SaleType"
                            >
                              <v-text-field
                                v-model="editedQuotation.SaleType"
                                :label="$t('month_sale_item_sale_type')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              xl="3"
                              v-if="editedQuotation.SaleNumber"
                            >
                              <v-text-field
                                v-model="editedQuotation.SaleNumber"
                                :label="$t('month_sale_item_sale_number')"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="computeReviewDate"
                                label="審核時間"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedQuotation.ReviewBy"
                                label="審核人"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="computeInvalidDate"
                                :label="$t('quotation_invalid_date')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedQuotation.InvalidBy"
                                :label="$t('quotation_invalid_by')"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-textarea
                                outlined
                                v-model="editedQuotation.Remark"
                                :label="$t('quotation_item_remark')"
                                :disabled="isAllTextFieldDisabled"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-row v-if="editedQuotation.Type !== quotationType.TypeProjectPayItem">
                            <v-col>
                              <v-textarea
                                outlined
                                v-model="editedQuotation.WorkRemark"
                                label="派單備註"
                                :disabled="isAllTextFieldDisabled"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-row v-if="editedQuotation.IsInvalid">
                            <v-col>
                              <v-textarea
                                outlined
                                v-model="editedQuotation.InvalidReason"
                                label="作廢原因"
                                disabled
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-row v-if="editedQuotation.NotInvalidReason">
                            <v-col>
                              <v-textarea
                                outlined
                                v-model="editedQuotation.NotInvalidReason"
                                label="反作廢原因"
                                disabled
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-row
                            v-if="
                              editedQuotation.Type === quotationType.TypeProject ||
                                editedQuotation.Type === quotationType.TypeProjectPayItem
                            "
                          >
                            <v-card min-width="100%" elevation="1" class="mb-5">
                              <v-card-title>紀錄客戶資料</v-card-title>
                              <v-card-text>
                                <v-row>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.RecordCustomer.Number"
                                      label="客戶代號"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.RecordCustomer.ShortName"
                                      label="客戶簡稱"
                                      disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.RecordCustomer.FullName"
                                      label="客戶全名"
                                      disabled
                                    >
                                    </v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.RecordCustomer.Tel"
                                      label="電話"
                                      disabled
                                    >
                                    </v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.RecordCustomer.Fax"
                                      label="傳真"
                                      disabled
                                    >
                                    </v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.RecordCustomer.Attribute"
                                      label="統一編號"
                                      disabled
                                    >
                                    </v-text-field>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-text-field
                                      v-model="editedQuotation.RecordCustomer.InvoiceAddress"
                                      label="登記地址"
                                      disabled
                                    >
                                    </v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="3">
                                    <v-autocomplete
                                      v-model="editedQuotation.RecordCustomer.CurrencyNo"
                                      :items="currencyList"
                                      item-text="Mf002"
                                      item-value="Mf001"
                                      disabled
                                      label="幣別"
                                      :loading-text="$t('common_get_data')"
                                      :no-data-text="$t('common_no_results')"
                                    ></v-autocomplete>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-autocomplete
                                      v-model="editedQuotation.RecordCustomer.InvoiceType"
                                      :items="invoiceList"
                                      item-text="Name"
                                      item-value="Type"
                                      disabled
                                      label="發票聯數"
                                      :loading-text="$t('common_get_data')"
                                      :no-data-text="$t('common_no_results')"
                                    ></v-autocomplete>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-row>
                        </ValidationObserver>
                      </v-container>
                    </v-card-text>

                    <new-install-car
                      class="ma-5"
                      v-if="editedQuotation.Type === quotationType.TypeNewInstall"
                      :carQuantity="carQuantity"
                      :newInstallItemList="editedQuotation.QuotationItems"
                      :monthItemList="editedQuotation.MonthItems"
                      :payItemList="editedQuotation.PayItems"
                      :discountItemList="editedQuotation.DiscountItems"
                      :isAllTextFieldDisabled="isAllTextFieldDisabled"
                      :repairCustomerId="editedQuotation.Customer.Id"
                      :allPayType="allPayType"
                      :allPayQuantityType="allPayQuantityType"
                      :acceptanceNoticeType="editedQuotation.NoticeType"
                      :fatherTempStockList="tempStockList"
                      @setNewInstall="setNewInstall"
                      @setEditNewInstall="getEditNewInstall"
                      @setNewInstallIndex="getEditNewInstallIndex"
                      @setNewInstallDeleteIndex="getNewInstallDeleteIndex"
                      @setNewInstallEditBomItemIndex="getEditNewInstallBomItemIndex"
                      @setNewInstallDeleteBomItemIndex="getNewInstallDeleteBomItemIndex"
                      @setDeleteNewInstall="getNewInstallDelete"
                      @setAllMonth="setAllMonth"
                      @setMonthItemIndex="setMonthItemIndex"
                      @setMonthBomItemIndex="setMonthBomItemIndex"
                      @setMonthItem="setMonthItem"
                      @setBomMonth="setBomMonth"
                      @deleteMonthItem="deleteMonthItem"
                      @setPayItemIndex="setPayItemIndex"
                      @setAllPay="setAllPay"
                      @setPayItem="setPayItem"
                      @deletePayItem="deletePayItem"
                      @computedAmt="computedAmt"
                      @setDiscountItem="setDiscountItem"
                      @setDiscountItemIndex="setDiscountItemIndex"
                      @deleteDiscountItem="deleteDiscountItem"
                      @setAllDiscount="setAllDiscount"
                    />
                    <remove-car
                      class="ma-5"
                      v-if="editedQuotation.Type === quotationType.TypeRemoveCar"
                      :carQuantity="carQuantity"
                      :payItemList="editedQuotation.PayItems"
                      :isAllTextFieldDisabled="isAllTextFieldDisabled"
                      :removeItemList="editedQuotation.RemovedItems"
                      :monthItemList="editedQuotation.MonthItems"
                      :repairCustomerId="editedQuotation.Customer.Id"
                      :allPayType="allPayType"
                      :allPayQuantityType="allPayQuantityType"
                      @setRemove="setRemove"
                      @setEditRemoveCar="getEditRemoveCar"
                      @setRemoveCarIndex="getEditRemoveCarIndex"
                      @setRemoveCarDeleteIndex="getDeleteRemoveCarIndexToDelete"
                      @setAllMonth="setAllMonth"
                      @setAllPay="setAllPay"
                      @setPayItemIndex="setPayItemIndex"
                      @setPayItem="setPayItem"
                      @deletePayItem="deletePayItem"
                      @computedAmt="computedAmt"
                      @setMonthItemIndex="setMonthItemIndex"
                      @setMonthItem="setMonthItem"
                      @deleteMonthItem="deleteMonthItem"
                    />
                    <return-car
                      class="ma-5"
                      v-if="editedQuotation.Type === quotationType.TypeReturnCar"
                      :discountItemList="editedQuotation.DiscountItems"
                      :returnItemList="editedQuotation.ReturnItems"
                      :fatherNewItemList="editedQuotation.QuotationItems"
                      :isAllTextFieldDisabled="isAllTextFieldDisabled"
                      :carQuantity="carQuantity"
                      :monthItemList="editedQuotation.MonthItems"
                      :payItemList="editedQuotation.PayItems"
                      :repairCustomerId="editedQuotation.Customer.Id"
                      :allPayType="allPayType"
                      :allPayQuantityType="allPayQuantityType"
                      :fatherTempStockList="tempStockList"
                      @setNewItemIndex="getNewItemIndex"
                      @setNewItem="setNewItem"
                      @setEditedNewItem="getNewItem"
                      @setNewBomItemIndex="getNewItemBomItemIndex"
                      @setNewItemDeleteIndex="getNewItemDeleteIndex"
                      @setNewBomItemDeleteIndex="getDeleteNewBomItemIndex"
                      @setReturn="setReturn"
                      @setReturnItemIndex="getReturnItemIndex"
                      @setEditedReturnItem="getEditedReturnItem"
                      @setReturnItemDeleteIndex="getReturnItemDeleteIndex"
                      @setAllPay="setAllPay"
                      @setPayItemIndex="setPayItemIndex"
                      @setPayItem="setPayItem"
                      @deletePayItem="deletePayItem"
                      @setAllMonth="setAllMonth"
                      @setMonthItemIndex="setMonthItemIndex"
                      @setMonthItem="setMonthItem"
                      @deleteMonthItem="deleteMonthItem"
                      @computedAmt="computedAmt"
                      @setDiscountItem="setDiscountItem"
                      @setDiscountItemIndex="setDiscountItemIndex"
                      @deleteDiscountItem="deleteDiscountItem"
                      @setAllDiscount="setAllDiscount"
                    />
                    <repair
                      class="ma-5"
                      v-if="editedQuotation.Type === quotationType.TypeRepair"
                      :offsetList="editedQuotation.OffsetItems"
                      :isAllTextFieldDisabled="isAllTextFieldDisabled"
                      :carQuantity="carQuantity"
                      :customerId="editedQuotation.Customer.Id"
                      :quotationNumberType="editedQuotation.NumberType"
                      :payItemList="editedQuotation.PayItems"
                      @setOffsetItemIndex="setOffsetItemIndex"
                      @setEditedOffsetItem="setEditedOffsetItem"
                      @setOffsetItem="setOffsetItem"
                      @deleteOffsetItem="deleteOffsetItem"
                      @setAllPay="setAllPay"
                      @setPayItemIndex="setPayItemIndex"
                      @setPayItem="setPayItem"
                      @deletePayItem="deletePayItem"
                      @setRemoveOffsetItem="setRemoveOffsetItem"
                    />
                    <month
                      class="ma-5"
                      v-if="editedQuotation.Type === quotationType.TypeMonth"
                      :isAllTextFieldDisabled="isAllTextFieldDisabled"
                      :carQuantity="carQuantity"
                      :monthItemList="editedQuotation.MonthItems"
                      :payItemList="editedQuotation.PayItems"
                      :allPayType="allPayType"
                      :allPayQuantityType="allPayQuantityType"
                      :discountItemList="editedQuotation.DiscountItems"
                      @setAllPay="setAllPay"
                      @setPayItemIndex="setPayItemIndex"
                      @setPayItem="setPayItem"
                      @deletePayItem="deletePayItem"
                      @setAllMonth="setAllMonth"
                      @setMonthItemIndex="setMonthItemIndex"
                      @setMonthItem="setMonthItem"
                      @deleteMonthItem="deleteMonthItem"
                      @computedAmt="computedAmt"
                      @setDiscountItem="setDiscountItem"
                      @setDiscountItemIndex="setDiscountItemIndex"
                      @deleteDiscountItem="deleteDiscountItem"
                      @setAllDiscount="setAllDiscount"
                    />
                    <offset
                      class="ma-5"
                      v-if="editedQuotation.Type === quotationType.TypeOffset"
                      :offsetList="editedQuotation.OffsetItems"
                      :isAllTextFieldDisabled="isAllTextFieldDisabled"
                      :customerId="editedQuotation.Customer.Id"
                      :payItemList="editedQuotation.PayItems"
                      :carQuantity="carQuantity"
                      @setOffsetItemIndex="setOffsetItemIndex"
                      @setEditedOffsetItem="setEditedOffsetItem"
                      @setOffsetItem="setOffsetItem"
                      @setAllPay="setAllPay"
                      @setPayItemIndex="setPayItemIndex"
                      @setPayItem="setPayItem"
                      @deletePayItem="deletePayItem"
                    />
                    <move-car
                      class="ma-5"
                      v-if="editedQuotation.Type === quotationType.TypeMove"
                      :discountItemList="editedQuotation.DiscountItems"
                      :moveItemList="editedQuotation.MoveItems"
                      :fatherNewItemList="editedQuotation.QuotationItems"
                      :isAllTextFieldDisabled="isAllTextFieldDisabled"
                      :carQuantity="carQuantity"
                      :monthItemList="editedQuotation.MoveMonthItems"
                      :payItemList="editedQuotation.PayItems"
                      :repairCustomerId="editedQuotation.Customer.Id"
                      :allPayType="allPayType"
                      :allPayQuantityType="allPayQuantityType"
                      :fatherTempStockList="tempStockList"
                      @setNewItemIndex="getNewItemIndex"
                      @setNewItem="setNewItem"
                      @setEditedNewItem="getNewItem"
                      @setNewBomItemIndex="getNewItemBomItemIndex"
                      @setNewItemDeleteIndex="getNewItemDeleteIndex"
                      @setNewBomItemDeleteIndex="getDeleteNewBomItemIndex"
                      @setMove="setMove"
                      @setMoveItemIndex="setMoveItemIndex"
                      @setEditedMoveItem="setEditedMoveItem"
                      @setMoveItemDeleteIndex="setMoveItemDeleteIndex"
                      @setAllPay="setAllPay"
                      @setPayItemIndex="setPayItemIndex"
                      @setPayItem="setPayItem"
                      @deletePayItem="deletePayItem"
                      @setAllMoveMonth="setAllMoveMonth"
                      @setMonthItemIndex="setMonthItemIndex"
                      @setMoveMonthItem="setMoveMonthItem"
                      @deleteMoveMonthItem="deleteMoveMonthItem"
                      @computedAmt="computedAmt"
                      @setDiscountItem="setDiscountItem"
                      @setDiscountItemIndex="setDiscountItemIndex"
                      @deleteDiscountItem="deleteDiscountItem"
                      @setAllDiscount="setAllDiscount"
                    />
                    <project
                      class="ma-5"
                      v-if="editedQuotation.Type === quotationType.TypeProject"
                      :carQuantity="carQuantity"
                      :newInstallItemList="editedQuotation.QuotationItems"
                      :monthItemList="editedQuotation.MonthItems"
                      :payItemList="editedQuotation.PayItems"
                      :discountItemList="editedQuotation.DiscountItems"
                      :isAllTextFieldDisabled="isAllTextFieldDisabled"
                      :repairCustomerId="editedQuotation.Customer.Id"
                      :allPayType="allPayType"
                      :allPayQuantityType="allPayQuantityType"
                      @setNewInstall="setNewInstall"
                      @setEditNewInstall="getEditNewInstall"
                      @setNewInstallIndex="getEditNewInstallIndex"
                      @setNewInstallDeleteIndex="getNewInstallDeleteIndex"
                      @setNewInstallEditBomItemIndex="getEditNewInstallBomItemIndex"
                      @setNewInstallDeleteBomItemIndex="getNewInstallDeleteBomItemIndex"
                      @setDeleteNewInstall="getNewInstallDelete"
                      @setAllMonth="setAllMonth"
                      @setMonthItemIndex="setMonthItemIndex"
                      @setMonthBomItemIndex="setMonthBomItemIndex"
                      @setMonthItem="setMonthItem"
                      @setBomMonth="setBomMonth"
                      @deleteMonthItem="deleteMonthItem"
                      @setPayItemIndex="setPayItemIndex"
                      @setAllPay="setAllPay"
                      @setPayItem="setPayItem"
                      @deletePayItem="deletePayItem"
                      @computedAmt="computedAmt"
                      @setDiscountItem="setDiscountItem"
                      @setDiscountItemIndex="setDiscountItemIndex"
                      @deleteDiscountItem="deleteDiscountItem"
                      @setAllDiscount="setAllDiscount"
                    />
                    <try-install
                      class="ma-5"
                      v-if="editedQuotation.Type === quotationType.TypeTryInstall"
                      :carQuantity="carQuantity"
                      :tryInstallItemList="editedQuotation.TryInstallItems"
                      :monthItemList="editedQuotation.MonthItems"
                      :payItemList="editedQuotation.PayItems"
                      :isAllTextFieldDisabled="isAllTextFieldDisabled"
                      :repairCustomerId="editedQuotation.Customer.Id"
                      :allPayType="allPayType"
                      :allPayQuantityType="allPayQuantityType"
                      :fatherTempStockList="tempStockList"
                      @setTryInstall="setTryInstall"
                      @setEditTryInstall="setEditTryInstall"
                      @setTryInstallIndex="setTryInstallIndex"
                      @setTryInstallDeleteIndex="setTryInstallDeleteIndex"
                      @setTryInstallEditBomItemIndex="setTryInstallEditBomItemIndex"
                      @setTryInstallDeleteBomItemIndex="setTryInstallDeleteBomItemIndex"
                      @setDeleteTryInstall="setDeleteTryInstall"
                      @setAllMonth="setAllMonth"
                      @setMonthItemIndex="setMonthItemIndex"
                      @setMonthBomItemIndex="setMonthBomItemIndex"
                      @setMonthItem="setMonthItem"
                      @setBomMonth="setBomMonth"
                      @deleteMonthItem="deleteMonthItem"
                      @setPayItemIndex="setPayItemIndex"
                      @setAllPay="setAllPay"
                      @setPayItem="setPayItem"
                      @deletePayItem="deletePayItem"
                      @computedAmt="computedAmt"
                    />

                    <renew-month-setting
                      class="ma-5"
                      v-if="editedQuotation.Type === quotationType.TypeRenew"
                      :isAllTextFieldDisabled="isAllTextFieldDisabled"
                      :carQuantity="editedQuotation.CarQuantity"
                      :monthItemList="editedQuotation.MonthItems"
                      :allPayType="allPayType"
                      :allPayQuantityType="allPayQuantityType"
                      :renewMonthItemList="editedQuotation.RenewMonthItems"
                      :repairCustomerId="editedQuotation.Customer.Id"
                      @setMonthItemIndex="setMonthItemIndex"
                      @setMonthItem="setMonthItem"
                      @deleteRenewMonthItem="deleteRenewMonthItem"
                      @setEditedRenewMonthItemIndex="setEditedRenewMonthItemIndex"
                      @setEditedRenewMonthItem="setEditedRenewMonthItem"
                    />

                    <project-pay-item
                      class="ma-5"
                      v-if="editedQuotation.Type === quotationType.TypeProjectPayItem"
                      :isAllTextFieldDisabled="isAllTextFieldDisabled"
                      :customerId="editedQuotation.Customer.Id"
                      :payItemList="editedQuotation.PayItems"
                      @setAllPay="setAllPay"
                      @setPayItemIndex="setPayItemIndex"
                      @setPayItem="setPayItem"
                      @deletePayItem="deletePayItem"
                    />
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-2">
                  <v-card flat>
                    <v-card-text>
                      <vue-editor
                        v-model="editedQuotation.SelectQuotationTerm.Content"
                        :disabled="isAllTextFieldDisabled"
                        :editor-toolbar="customToolbar"
                      ></vue-editor>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-3">
                  <v-card flat>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <v-text-field
                              v-model="editedQuotation.TpAccount"
                              label="環保帳號"
                              :disabled="isAllTextFieldDisabled"
                              @keyup.enter="focusNextInput"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <v-text-field
                              v-model="editedQuotation.TpPassword"
                              label="環保密碼"
                              :disabled="isAllTextFieldDisabled"
                              @keyup.enter="focusNextInput"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedQuotation"
                  :disabled="isLoadingSaveBtn"
                >
                  {{ $t('common_close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="isQuotationThrow" max-width="500" persistent>
            <v-card :color="isSuccess ? 'success' : 'error'">
              <v-card-title class="text-h1"></v-card-title>
              <v-card-text class="white--text text-h5" v-if="isSuccess">
                <v-icon class="white--text text--lighten-1">mdi-checkbox-marked-circle</v-icon>
                {{ $t('quotation_quotation_throw_alert_success') }}
              </v-card-text>
              <v-card-text class="white--text text-h5" v-else>
                <v-icon class="white--text text--lighten-1">mdi-alert-outline</v-icon>
                {{ $t('quotation_quotation_throw_alert_error') }}
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="white" text @click="isQuotationThrow = false">
                  {{ $t('common_close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="isQuotationItemNullDialog" max-width="500" persistent>
            <v-card color="error">
              <v-card-title class="text-h1"></v-card-title>
              <v-card-text class="white--text text-h5">
                <v-icon class="white--text text--lighten-1">mdi-alert-octagon</v-icon>
                {{ $t('quotation_save_alert') }}
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="white" text @click="isQuotationItemNullDialog = false">
                  {{ $t('common_close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog persistent v-model="isShowCheckTempStockDialog" max-width="500">
            <v-card>
              <v-card-title>以下品項庫存不足，請與倉管確認庫存!!!</v-card-title>
              <v-card-text>
                <v-card v-for="item in infoTempStockMessageList" :key="item.Index" class="ma-5">
                  <v-card-title></v-card-title>
                  <v-card-text>
                    <p v-if="item.BomName">Bom名稱: {{ item.BomName }}</p>
                    <p v-if="item.BomName">Bom描述: {{ item.BomDescribe }}</p>
                    <p>品號: {{ item.Number }}</p>
                    <p>品名: {{ item.Name }}</p>
                    <p>實際庫存: {{ item.TempStockQuantity }}</p>
                    <p>需求數量: {{ item.NeedQuantity }}</p>
                  </v-card-text>
                </v-card>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="error"
                  text
                  @click="isShowCheckTempStockDialog = false"
                  :disabled="isLoadingSaveBtn"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn color="success" text @click="saveQuotation" :loading="isLoadingSaveBtn">
                  {{ $t('common_save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isAllTextFieldDisabled"
            :isLoadingSaveBtn="isLoadingSaveBtn"
            :isShowDeleteDialog="isShowDeleteQuotationDialog"
            :deleteMessage="'quotation_delete_dialog_title'"
            @closeDelete="closeDeleteQuotation"
            @confirmDelete="confirmDeleteQuotation"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.CreateTime`]="{ item }">
        {{ convertToDateTimeFormat(item.CreateTime) }}
      </template>
      <template v-slot:[`item.SignDate`]="{ item }">
        {{ convertToDateTimeFormat(item.SignDate) }}
      </template>
      <template v-slot:[`item.Type`]="{ item }">
        {{ turnTypeName(item.Type) }}
      </template>
      <template v-slot:[`item.Customer`]="{ item }">
        {{ item.Customer.Number }}
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditQuotationDialogBtn(item)" v-if="item.IsDone">
          <v-icon small>
            mdi-eye
          </v-icon>
        </v-btn>
        <v-btn icon @click="isShowEditQuotationDialogBtn(item)" v-if="!item.IsDone">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn icon @click="isShowDeleteQuotationDialogBtn(item)" v-if="!item.IsDone">
          <v-icon small>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.Status`]="{ item }">
        {{ methodsStatus(item) }}
      </template>
      <template v-slot:[`item.SpecialNeedList`]="{ item }">
        {{ turnSpecialNeedName(item.SpecialNeedList) }}
      </template>
      <template v-slot:[`item.LicensePlateList`]="{ item }">
        <div v-if="item.LicensePlateList.length > 2">
          <v-chip v-for="index in 2" :key="index" small>
            {{ item.LicensePlateList[index - 1] }}
          </v-chip>
          +({{ item.LicensePlateList.length - 2 }})
        </div>
        <div v-else>
          <v-chip v-for="licensePlate in item.LicensePlateList" :key="licensePlate" small>
            {{ licensePlate }}
          </v-chip>
        </div>
      </template>
      <template v-slot:[`item.data-table-expand`]="{ item, isExpanded, expand }">
        <v-btn v-if="hasHardwareItems(item)" icon small @click.stop="expand(!isExpanded)">
          <v-icon>{{ isExpanded ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pa-3">
          <div class="caption grey--text mb-1">硬體設備</div>
          <v-simple-table dense>
            <thead>
              <tr>
                <th>品號</th>
                <th>品名</th>
                <th>數量</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in hardwareItems(item)" :key="idx">
                <td>{{ row.Number }}</td>
                <td>{{ row.Name }}</td>
                <td>{{ row.Quantity || row.BuyQuantity || row.RealQuantity }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import NewInstallCar from '@/components/Quotation/NewInstallCar'
import RemoveCar from '@/components/Quotation/RemoveCar'
import ReturnCar from '@/components/Quotation/ReturnCar'
import Month from '@/components/Quotation/Month'
import Offset from '@/components/Quotation/Offset'
import Repair from '@/components/Quotation/Repair'
import {
  HttpQuotation,
  HttpFile,
  HttpResume,
  HttpMonth,
  HttpCmsmf,
  HttpSpecialNeed,
  HttpDivideQuotation,
  HttpCustomer,
  HttpPageChangeRecord,
  HttpDiscount,
  HttpOverage,
  HttpCustomerLicensePlateMapping,
  HttpTempStock,
  HttpTransferOrder
} from '@/js/http-Manager' //, HttpCustomerRepair,HttpDiscount
import { InvoiceType } from '@/js/InvoiceType'
import { MonthStatus } from '@/js/MonthStatus'
import { FixType } from '@/js/FixType'
import { NoticeType } from '@/js/NoticeType'
import { QuotationType } from '@/js/QuotationType'
import { NumberType } from '@/js/NumberType'
import { extend } from 'vee-validate'
import { regex, min, max, min_value } from 'vee-validate/dist/rules'
import axios from 'axios'
import { mapGetters } from 'vuex'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import DatePickerSignDate from '@/components/DatePickerSignDate.vue'
import DatePickerExpDate from '@/components/DatePickerExpDate.vue'
import QuotationCustomerAutocomplete from '@/components/QuotationCustomerAutocomplete.vue'
import { VueEditor } from 'vue2-editor'
import DatePickerSetTime from '@/components/DatePickerSetTime.vue'
import MoveCar from '@/components/Quotation/MoveCar.vue'
import Project from '@/components/Quotation/Project.vue'
import SelectMergeQuotation from '@/components/Quotation/SelectMergeQuotation.vue'
import QuotationChangeDetail from '@/components/ChangeDetail/QuotationChangeDetail.vue'
import DatePickerSetTimeNotRequest from '@/components/DatePickerSetTimeNotRequest.vue'
import FixNumberAutocomplete from '@/components/Quotation/FixNumberAutocomplete/FixNumberAutocomplete.vue'
import RepairNumberAutocomplete from '@/components/Quotation/ReapirNumberAutocomplete/RepairNumberAutocomplete.vue'
import TryInstall from '@/components/Quotation/TryInstall.vue'
import AcceptanceNumberAutocomplete from '@/components/Quotation/AcceptanceNumberAutocomplete/AcceptanceNumberAutocomplete.vue'
import QuotationCustomerCombobox from '@/components/QuotationCustomerCombobox.vue'
import NotInvalidBtn from '@/components/Quotation/Btn/NotInvalidBtn.vue'
import LicensePlateBatchInputButton from '@/components/ChangeDetail/LicensePlateBatchInputButton.vue'
import RenewMonthSetting from '../components/Quotation/MonthItem/RenewMonthSetting.vue'
import ProjectPayItem from '../components/Quotation/ProjectPayItem.vue'
import { PayType } from '@/js/PayType'

extend('min', min)
extend('max', max)
extend('min_value', min_value)
extend('regex', regex)

export default {
  name: 'Quotation',
  data: () => ({
    isDoneTransferOrderNumberStatus: false,
    payType: PayType,
    quotationNumber: '',
    isLoadingSelectType: false,
    invoiceType: InvoiceType,
    monthStatus: MonthStatus,
    numberType: NumberType,
    quotationType: QuotationType,
    noticeType: NoticeType,
    editedQuotationTryInstallIndex: -1,
    deleteQuotationTryInstallIndex: -1,
    editedQuotationTryInstallBomItemIndex: -1,
    deleteQuotationTryInstallBomItemIndex: -1,
    customToolbar: [
      ['bold', 'italic', 'underline', 'strike']
      // [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }]
    ],
    isShowEditQuotationDialog: false,
    isShowDeleteQuotationDialog: false,
    quotationList: [],
    editedQuotationIndex: -1,
    searchQuotation: '',
    editedQuotation: {
      Type: 0,
      Name: 0,
      Number: '',
      SignDate: 0,
      ExpDate: 0,
      TryInstallTime: 0,
      CreateTime: 0,
      CreateBy: '',
      OriginalCustomer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: '',
        SettleDay: 0
      },
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: '',
        SettleDay: 0
      },
      RecordCustomer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: '',
        SettleDay: 0
      },
      Accessory: '',
      ContactName: '',
      ContactPhone: '',
      CarPlace: '',
      CarQuantity: 1,
      RemovedReason: 0,
      LicensePlate: '',
      LicensePlateList: [],
      OriginalLicensePlate: '',
      ItemAmt: 0,
      ItemTax: 0,
      ItemTotalAmt: 0,
      ItemDiscountPrice: 0,
      ItemDiscount: 0,
      MonthAmt: 0,
      MonthTax: 0,
      MonthTotalAmt: 0,
      PayAmt: 0,
      PayTax: 0,
      PayTotalAmt: 0,
      PayDiscountPrice: 0,
      PayDiscount: 0,
      IsConfirm: false,
      ErpType: '',
      ErpNumber: '',
      FixType: 0,
      FixNumber: '',
      NoticeType: 0,
      NoticeNumber: '',
      OffsetItems: [],
      TryInstallItems: [],
      QuotationItems: [],
      MonthItems: [],
      PayItems: [],
      RemovedItems: [],
      ReturnItems: [],
      DiscountItems: [],
      MoveItems: [],
      MoveMonthItems: [],
      RenewMonthItems: [],
      IsConfirmQuotation: false,
      IsExportQuotation: false,
      SelectQuotationTerm: {
        Name: '',
        Type: 0,
        Content: ''
      },
      IsThrow: false,
      ThrowUsers: [],
      Remark: '',
      WorkRemark: '',
      Subject: '',
      FileDoneTime: 0,
      IsInvalid: false,
      InvalidTime: 0,
      InvalidBy: '',
      InvalidReason: '',
      NotInvalidReason: '',
      SpecialNeedList: [],
      TpAccount: '',
      TpPassword: '',
      IsThrowMonth: false,
      MonthStartTime: 0,
      RenewMonthTime: 0,
      OriginalNumber: '',
      SaleType: '',
      SaleNumber: '',
      AcceptanceNoticeType: 0,
      AcceptanceNumber: '',
      RepairNumber: '',
      IsThrowToResume: false,
      Brand: '',
      IsDone: false,
      ReviewBy: '',
      ReviewTime: 0,
      SpecifyStopTime: 0,
      NumberType: 0,
      CopyNumber: '',
      OriginalTryInstallNumber: ''
    },
    defaultQuotation: {
      Type: 0,
      Name: 0,
      Number: '',
      SignDate: 0,
      ExpDate: 0,
      TryInstallTime: 0,
      CreateTime: 0,
      CreateBy: '',
      OriginalCustomer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: '',
        SettleDay: 0
      },
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: '',
        SettleDay: 0
      },
      RecordCustomer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: '',
        SettleDay: 0
      },
      Accessory: '',
      ContactName: '',
      ContactPhone: '',
      CarPlace: '',
      CarQuantity: 1,
      RemovedReason: 0,
      LicensePlate: '',
      LicensePlateList: [],
      OriginalLicensePlate: '',
      ItemAmt: 0,
      ItemTax: 0,
      ItemTotalAmt: 0,
      ItemDiscountPrice: 0,
      ItemDiscount: 0,
      MonthAmt: 0,
      MonthTax: 0,
      MonthTotalAmt: 0,
      PayAmt: 0,
      PayTax: 0,
      PayTotalAmt: 0,
      PayDiscountPrice: 0,
      PayDiscount: 0,
      IsConfirm: false,
      ErpType: '',
      ErpNumber: '',
      FixType: 0,
      FixNumber: '',
      NoticeType: 0,
      NoticeNumber: '',
      OffsetItems: [],
      TryInstallItems: [],
      QuotationItems: [],
      MonthItems: [],
      PayItems: [],
      RemovedItems: [],
      ReturnItems: [],
      DiscountItems: [],
      MoveItems: [],
      MoveMonthItems: [],
      RenewMonthItems: [],
      IsConfirmQuotation: false,
      IsExportQuotation: false,
      SelectQuotationTerm: {
        Name: '',
        Type: 0,
        Content: ''
      },
      IsThrow: false,
      ThrowUsers: [],
      Remark: '',
      WorkRemark: '',
      Subject: '',
      FileDoneTime: 0,
      IsInvalid: false,
      InvalidTime: 0,
      InvalidBy: '',
      InvalidReason: '',
      NotInvalidReason: '',
      SpecialNeedList: [],
      TpAccount: '',
      TpPassword: '',
      IsThrowMonth: false,
      MonthStartTime: 0,
      RenewMonthTime: 0,
      OriginalNumber: '',
      SaleType: '',
      SaleNumber: '',
      AcceptanceNoticeType: 0,
      AcceptanceNumber: '',
      RepairNumber: '',
      IsThrowToResume: false,
      Brand: '',
      IsDone: false,
      ReviewBy: '',
      ReviewTime: 0,
      SpecifyStopTime: 0,
      NumberType: 0,
      CopyNumber: '',
      OriginalTryInstallNumber: ''
    },
    tempQuotation: {
      Type: 0,
      Name: 0,
      Number: '',
      SignDate: 0,
      ExpDate: 0,
      TryInstallTime: 0,
      CreateTime: 0,
      CreateBy: '',
      OriginalCustomer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: '',
        SettleDay: 0
      },
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: '',
        SettleDay: 0
      },
      RecordCustomer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: '',
        SettleDay: 0
      },
      Accessory: '',
      ContactName: '',
      ContactPhone: '',
      CarPlace: '',
      CarQuantity: 1,
      RemovedReason: 0,
      LicensePlate: '',
      LicensePlateList: [],
      OriginalLicensePlate: '',
      ItemAmt: 0,
      ItemTax: 0,
      ItemTotalAmt: 0,
      ItemDiscountPrice: 0,
      ItemDiscount: 0,
      MonthAmt: 0,
      MonthTax: 0,
      MonthTotalAmt: 0,
      PayAmt: 0,
      PayTax: 0,
      PayTotalAmt: 0,
      PayDiscountPrice: 0,
      PayDiscount: 0,
      IsConfirm: false,
      ErpType: '',
      ErpNumber: '',
      FixType: 0,
      FixNumber: '',
      NoticeType: 0,
      NoticeNumber: '',
      OffsetItems: [],
      TryInstallItems: [],
      QuotationItems: [],
      MonthItems: [],
      PayItems: [],
      RemovedItems: [],
      ReturnItems: [],
      DiscountItems: [],
      MoveItems: [],
      MoveMonthItems: [],
      RenewMonthItems: [],
      IsConfirmQuotation: false,
      IsExportQuotation: false,
      SelectQuotationTerm: {
        Name: '',
        Type: 0,
        Content: ''
      },
      IsThrow: false,
      ThrowUsers: [],
      Remark: '',
      WorkRemark: '',
      Subject: '',
      FileDoneTime: 0,
      IsInvalid: false,
      InvalidTime: 0,
      InvalidBy: '',
      InvalidReason: '',
      NotInvalidReason: '',
      SpecialNeedList: [],
      TpAccount: '',
      TpPassword: '',
      IsThrowMonth: false,
      MonthStartTime: 0,
      RenewMonthTime: 0,
      OriginalNumber: '',
      SaleType: '',
      SaleNumber: '',
      AcceptanceNoticeType: 0,
      AcceptanceNumber: '',
      RepairNumber: '',
      IsThrowToResume: false,
      Brand: '',
      IsDone: false,
      ReviewBy: '',
      ReviewTime: 0,
      SpecifyStopTime: 0,
      NumberType: 0,
      CopyNumber: '',
      OriginalTryInstallNumber: ''
    },
    allQuotationType: [],
    allCust: [],
    allRemovedReason: [],
    editedQuotationNewInstallIndex: -1,
    editedQuotationRemoveCarIndex: -1,
    newItemIndex: -1,
    filterQuotation: {
      Type: 0,
      Number: '',
      CustomerId: '',
      LicensePlate: '',
      OriginalLicensePlate: '',
      Subject: '',
      SpecialNeedId: ''
    },
    signDateStartMenu: false,
    signDateEndMenu: false,
    expandedQuotations: [],
    editedQuotationNewInstallBomItemIndex: -1,
    isLoadingQuotation: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisabled: false,
    deleteQuotationNewInstallBomItemIndex: -1,
    deleteQuotationNewInstallIndex: -1,
    deleteNewBomItemIndex: -1,
    deleteNewItemIndex: -1,
    newBomItemIndex: -1,
    isQuotationItemNullDialog: false,
    quotationSource: null,
    custSource: null,
    quotationTypesSource: null,
    addQuotationSource: null,
    updateQuotationSource: null,
    deleteQuotationSource: null,
    totalRows: 0,
    currentOptions: {
      page: 1,
      itemsPerPage: 30,
      sortBy: ['CreateTime'],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: true
    },
    isUpdateEventTotal: true,
    countTotalRowsSource: null,
    ImportExcelFile: null,
    isUploadDialog: false,
    allQuotationTerms: [],
    uploadRecord: {
      Type: 0,
      Number: '',
      Accessory: '',
      AccessoryRemark: ''
    },
    isQuotationThrow: false,
    isSuccess: false,
    isCopy: false,
    resume: null,
    fileDate: '',
    monthItemIndex: -1,
    payItemIndex: -1,
    returnItemIndex: -1,
    invoiceList: [],
    currencyList: [],
    allSpecialNeedList: [],
    tempSpecialNeedList: [],
    selectQuotationTerm: '',
    offsetItemIndex: -1,
    discountItemIndex: -1,
    customerLicensePlateList: [],
    customerOriginalLicensePlateList: [],
    // searchLicensePlateInput: '',
    // searchOriginalLicensePlateInput: '',
    monthBomItemIndex: -1,
    moveItemIndex: -1,
    allPayType: [],
    allPayQuantityType: [],
    errorMessage: '',
    existErrorMessage: '',
    quantityErrorMessage: '',
    carQuantity: 1,
    regexQuantity: /^[0-9]+$/,
    regexPrice: /^[0-9]+$/,
    isShowSelectMergeQuotation: false,
    isShowChangeDetailPageDialog: false,
    numberTypeList: [
      {
        Type: 6,
        Name: '叫修單'
      },
      {
        Type: 8,
        Name: '安裝驗收單'
      },
      {
        Type: 9,
        Name: '維修單'
      }
    ],
    isShowSelectTypeDialog: false,
    editedCustomer: {
      Number: '',
      ShortName: '',
      Tel: '',
      Fax: '',
      Attribute: '',
      InvoiceAddress: '',
      CurrencyNo: '',
      InvoiceType: '',
      SettleDay: 0
    },
    defaultCustomer: {
      Number: '',
      ShortName: '',
      Tel: '',
      Fax: '',
      Attribute: '',
      InvoiceAddress: '',
      CurrencyNo: '',
      InvoiceType: '',
      SettleDay: 0
    },
    tryInstallQuotationList: [],
    isShowInvalidQuotationDialog: false,
    invalidReason: '',
    selectedType: null,
    tempStockList: [],
    isShowCheckTempStockDialog: false,
    infoTempStockMessageList: [],
    renewMonthItemIndex: -1,
    isShowHardwareSummaryDialog: false,
    hardwareSummaryRows: [],
    expandedSummaryRows: []
  }),
  computed: {
    hardwareSummaryHeaders () {
      return [
        { text: '客戶名稱', value: 'CustomerName' },
        { text: '車牌', value: 'LicensePlate' },
        { text: '主旨', value: 'Subject' },
        { text: '回簽日期', value: 'SignDateText' },
        { text: '細項總數', value: 'ItemCount', align: 'end' }
      ]
    },
    isCopyLockedByLegacyDate () {
      if (this.editedQuotationIndex === -1 || !this.editedQuotation.CreateTime) {
        return false
      } // ✅ 未選取時返回 false
      const cutoffDate = new Date('2026-06-25T00:00:00+08:00').getTime()
      return this.editedQuotation.CreateTime < cutoffDate
    },
    typeList () {
      if (this.editedQuotation.MonthItems.length > 0) {
        return [
          {
            Type: 1,
            Name: '新裝機'
          }
        ]
      } else {
        return [
          {
            Type: 1,
            Name: '新裝機'
          },
          {
            Type: 4,
            Name: '維修'
          }
        ]
      }
    },
    isNeedFullName () {
      return (
        this.editedQuotation.Customer.Number === '' || this.editedQuotation.Customer.Number === null
      )
    },
    quotationDataTableHeaders () {
      return [
        {
          text: this.$t('quotation_name'),
          align: 'start',
          value: 'Type'
        },
        { text: this.$t('quotation_number'), align: 'start', value: 'Number' },
        {
          text: this.$t('quotation_create_time'),
          align: 'end',
          value: 'CreateTime'
        },
        {
          text: this.$t('quotation_customer_number'),
          align: 'center',
          value: 'Customer.Number',
          sortable: false
        },
        {
          text: this.$t('quotation_shortname'),
          align: 'center',
          value: 'Customer.ShortName',
          sortable: false
        },
        {
          text: this.$t('quotation_full_name'),
          align: 'center',
          value: 'Customer.FullName',
          sortable: false
        },
        {
          text: this.$t('quotation_license_plate'),
          align: 'center',
          value: 'LicensePlate'
        },
        {
          text: this.$t('quotation_license_plate') + '清單',
          align: 'center',
          value: 'LicensePlateList',
          sortable: false
        },
        {
          text: this.$t('quotation_original_license_plate'),
          align: 'center',
          value: 'OriginalLicensePlate'
        },
        {
          text: this.$t('quotation_subject'),
          align: 'start',
          value: 'Subject'
        },
        {
          text: this.$t('quotation_sign_date'),
          align: 'center',
          value: 'SignDate'
        },
        {
          text: this.$t('quotation_special_need'),
          align: 'center',
          value: 'SpecialNeedList',
          sortable: false
        },
        {
          text: this.$t('common_status'),
          align: 'center',
          value: 'Status',
          sortable: false
        },
        {
          text: this.$t('common_edit'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    quotationDialogTitle () {
      return this.editedQuotationIndex === -1
        ? this.$t('quotation_new_dialog_title')
        : this.$t('quotation_edit_dialog_title')
    },
    computeCreateTime () {
      return this.convertToDateTimeFormat(this.editedQuotation.CreateTime)
    },
    computeSignDate () {
      return this.convertToDateTimeFormat(this.editedQuotation.SignDate)
    },
    computeInvalidDate () {
      return this.convertToDateTimeFormat(this.editedQuotation.InvalidTime)
    },
    computeReviewDate () {
      return this.convertToDateTimeFormat(this.editedQuotation.ReviewTime)
    },
    computeTryInstallTime () {
      return this.convertToDateTimeFormat(this.editedQuotation.TryInstallTime)
    },
    computeExpDate () {
      return this.convertToDateTimeFormat(this.editedQuotation.ExpDate)
    },
    turnFormTypeName () {
      return InvoiceType.getFormTypeName(this.editedQuotation.Customer.InvoiceType)
    },
    turnFormFixTypeName () {
      return FixType.FixTypeName(this.editedQuotation.FixType)
    },
    turnNoticeType () {
      return NoticeType.getFormNoticeTypeName(this.editedQuotation.NoticeType)
    },
    ...mapGetters('login', {
      getUserAccountId: 'getUserAccountId',
      isRoleManagerOrAdmin: 'isRoleManagerOrAdmin',
      isRoleAdmin: 'isRoleAdmin'
    }),
    ThrowUsersLastName () {
      if (this.editedQuotation.ThrowUsers && this.editedQuotation.ThrowUsers.length !== 0) {
        return this.editedQuotation.ThrowUsers[this.editedQuotation.ThrowUsers.length - 1].Name
      }
      return ''
    },
    ThrowUsersLastTime () {
      if (this.editedQuotation.ThrowUsers && this.editedQuotation.ThrowUsers.length !== 0) {
        return this.convertToDateTimeFormat(
          this.editedQuotation.ThrowUsers[this.editedQuotation.ThrowUsers.length - 1].ThrowTime
        )
      }
      return 0
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    computedType () {
      let self = this
      let array = []
      this.allQuotationType.forEach((element) => {
        array.push(
          Object.assign(
            {
              disabled: element.Type === self.quotationType.TypeOffset
            },
            element
          )
        )
      })
      return array.sort((a, b) => a.disabled - b.disabled)
    },
    minDate () {
      if (this.editedQuotation.Customer && this.editedQuotation.Customer.Number) {
        let currentDate = new Date()
        let previousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
        let lastDayOfPreviousMonth = new Date(
          previousMonth.getFullYear(),
          previousMonth.getMonth() + 1,
          0
        ).getDate()

        let finalDay = Math.min(this.editedQuotation.Customer.SettleDay, lastDayOfPreviousMonth)
        let minDate = new Date(previousMonth.getFullYear(), previousMonth.getMonth(), finalDay + 1)
        return this.$moment(new Date(minDate)).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    isShowThrowSaleBtn () {
      if (this.editedQuotation.QuotationItems && this.editedQuotation.QuotationItems.length === 0) {
        return false
      }

      if (
        this.editedQuotation.AcceptanceNoticeType === this.noticeType.TryInstall ||
        this.editedQuotation.AcceptanceNoticeType === this.noticeType.AutoMakeTryInstall
      ) {
        let hasNeedInstall = false

        for (const element of this.editedQuotation.QuotationItems) {
          if (element.Number) {
            if (element.IsNeedInstall) {
              hasNeedInstall = true
              break
            }
          } else {
            for (const bomItem of element.BomItems) {
              if (bomItem.IsNeedInstall) {
                hasNeedInstall = true
                break
              }
            }

            if (hasNeedInstall) {
              break
            }
          }
        }

        return !hasNeedInstall
      }

      return false
    }
  },
  async mounted () {
    await this.getAllQuotationType()
    await this.getQuotationTerm()
    await this.getRemoveReason()
    await this.getAllQuotation()
    await this.countTotalRows()
    await this.getInvoiceType()
    await this.getCurrency()
    await this.getSpecialNeedList()
    await this.getAllPayType()
    await this.getAllPayQuantityType()
    await this.getIsConfirmTryInstallQuotations()
  },
  watch: {
    'editedQuotation.IsDone': {
      handler (val) {
        if (val) {
          this.isAllTextFieldDisabled = val
        }
      },
      deep: true
    },
    'editedQuotation.CarQuantity': {
      handler (val) {
        if (this.regexQuantity.test(val)) {
          this.carQuantity = val
        } else {
          this.carQuantity = 1
        }
      },
      deep: true
    }
  },
  methods: {
    async isThrowTransferOrderBtn () {
      this.editedQuotation.IsThrowTransferOrder = true
      let response = await HttpQuotation.QuotationTransferOrder(this.editedQuotation)
      if (response && response.status === 200) {
        await this.searchEditQuotation()
      }
    },
    openHardwareSummary () {
      this.hardwareSummaryRows = this.quotationList.map((q) => {
        const items = this.hardwareItems(q).map((row) => ({
          Number: row.Number || '',
          Name: row.Name || '',
          Quantity: Number(row.Quantity || row.BuyQuantity || row.RealQuantity || 0)
        }))
        return {
          Id: q.Id,
          CustomerName: (q.Customer && (q.Customer.ShortName || q.Customer.FullName)) || '',
          LicensePlate: q.LicensePlate || (q.LicensePlateList && q.LicensePlateList[0]) || '',
          Subject: q.Subject || '',
          SignDateText: q.SignDate ? this.convertToDateTimeFormat(q.SignDate) : '-',
          ItemCount: items.length,
          HardwareItems: items
        }
      })
      this.expandedSummaryRows = []
      this.isShowHardwareSummaryDialog = true
    },
    async getAllPayQuantityType () {
      let response = await HttpMonth.GetAllPayQuantityType()
      if (response && response.status === 200) {
        this.allPayQuantityType = response.data.Data
      }
    },
    async throwProjectPayItemToSale () {
      if (this.editedQuotation.Type === this.quotationType.TypeProjectPayItem) {
        this.editedQuotation.IsThrow = true
        this.editedQuotation.ThrowUsers.push({
          Name: this.getUserAccountId,
          ThrowTime: Date.parse(new Date())
        })
        let projectThrowData = {
          Quotation: this.editedQuotation,
          Customer: this.editedCustomer
        }
        let response = await HttpQuotation.TransferProjectPayItemToSale(projectThrowData)
        if (response && response.status === 200) {
          await this.searchEditQuotation()
        }
      }
    },
    async renewMonth () {
      if (this.editedQuotation.Type === this.quotationType.TypeRenew) {
        this.editedQuotation.IsThrow = true
        let response = await HttpMonth.UpdateRenewMonthFromQuotation(this.editedQuotation)
        if (
          response &&
          response.status === 200 &&
          this.editedQuotation.OriginalCustomer &&
          this.editedQuotation.OriginalCustomer.Number &&
          this.editedQuotation.MonthItems &&
          this.editedQuotation.MonthItems.length > 0
        ) {
          await this.getNumber()
          let param = {
            customerId: this.editedQuotation.OriginalCustomer.Id,
            licensePlate: this.editedQuotation.OriginalLicensePlate
          }
          let removeItems = []
          let brand = ''
          let itemResponse = await HttpResume.GetOneResume(param)
          if (itemResponse && itemResponse.status === 200) {
            brand = itemResponse.data.Data.Brand
            itemResponse.data.Data.ResumeItems.forEach((element) => {
              if (!element.IsRemoved) {
                element.Id = element.ItemId
                removeItems.push(element)
              }
            })
          }
          let removeQuotation = {
            Type: 2,
            Customer: this.editedQuotation.OriginalCustomer,
            Name: '拆機',
            Number: this.quotationNumber,
            SignDate: 0,
            ExpDate: this.editedQuotation.ExpDate,
            TryInstallTime: 0,
            CreateTime: 0,
            CreateBy: '',
            OriginalCustomer: {
              Number: '',
              ShortName: '',
              Tel: '',
              Fax: '',
              Attribute: '',
              InvoiceAddress: '',
              CurrencyNo: '',
              InvoiceType: '',
              SettleDay: 0
            },
            Accessory: '',
            ContactName: '',
            ContactPhone: '',
            CarPlace: '',
            CarQuantity: 1,
            RemovedReason: 3,
            LicensePlate: this.editedQuotation.OriginalLicensePlate,
            LicensePlateList: [],
            OriginalLicensePlate: '',
            ItemAmt: 0,
            ItemTax: 0,
            ItemTotalAmt: 0,
            ItemDiscountPrice: 0,
            ItemDiscount: 0,
            MonthAmt: 0,
            MonthTax: 0,
            MonthTotalAmt: 0,
            PayAmt: 0,
            PayTax: 0,
            PayTotalAmt: 0,
            PayDiscountPrice: 0,
            PayDiscount: 0,
            IsConfirm: false,
            ErpType: '',
            ErpNumber: '',
            FixType: 0,
            FixNumber: '',
            NoticeType: 0,
            NoticeNumber: '',
            OffsetItems: [],
            TryInstallItems: [],
            QuotationItems: [],
            MonthItems: this.editedQuotation.MonthItems,
            PayItems: [],
            RemovedItems: removeItems,
            ReturnItems: [],
            DiscountItems: [],
            MoveItems: [],
            MoveMonthItems: [],
            RenewMonthItems: [],
            IsConfirmQuotation: false,
            IsExportQuotation: false,
            SelectQuotationTerm: {
              Name: '',
              Type: 0,
              Content: ''
            },
            IsThrow: false,
            ThrowUsers: [],
            Remark: '',
            WorkRemark: '',
            Subject: '',
            FileDoneTime: 0,
            IsInvalid: false,
            InvalidTime: 0,
            InvalidBy: '',
            InvalidReason: '',
            NotInvalidReason: '',
            SpecialNeedList: [],
            TpAccount: '',
            TpPassword: '',
            IsThrowMonth: false,
            MonthStartTime: 0,
            RenewMonthTime: 0,
            OriginalNumber: '',
            SaleType: '',
            SaleNumber: '',
            AcceptanceNoticeType: 0,
            AcceptanceNumber: '',
            RepairNumber: '',
            IsThrowToResume: false,
            Brand: brand,
            IsDone: false,
            ReviewBy: '',
            ReviewTime: 0,
            SpecifyStopTime: this.editedQuotation.RenewMonthTime,
            NumberType: 0,
            CopyNumber: '',
            OriginalTryInstallNumber: ''
          }
          await HttpQuotation.AddQuotation(removeQuotation)
        }
        await HttpQuotation.UpdateQuotation(this.editedQuotation)
        await this.searchEditQuotation()
      }
    },
    async searchMonthForLicensePlate () {
      if (this.editedQuotation.Type === this.quotationType.TypeRenew) {
        let param = {
          customerId: this.editedQuotation.Customer.Id,
          licensePlates: this.editedQuotation.LicensePlateList.join(',')
        }

        let monthResponse = await HttpMonth.GetRenewMonthList(param)
        if (monthResponse && monthResponse.status === 200) {
          monthResponse.data.Data.forEach((element) => {
            let renewItemIndex = this.editedQuotation.RenewMonthItems.findIndex(
              (x) => x.MonthNumber === element.Number
            )

            if (renewItemIndex === -1) {
              let renewMonthItemParam = {
                Number: element.ItemNumber,
                Name: element.ItemName,
                LicensePlate: element.LicensePlate,
                RentWarrantyPeriod: element.RentWarrantyPeriod,
                AddRentWarrantyPeriod: 0,
                TotalRentWarrantyPeriod: element.RentWarrantyPeriod,
                RenewReason: '',
                MonthNumber: element.Number
              }
              this.editedQuotation.RenewMonthItems.push(renewMonthItemParam)
            } else {
              let renewMonthItemParam = this.editedQuotation.RenewMonthItems[renewItemIndex]
              this.editedQuotation.RenewMonthItems.splice(renewItemIndex, 1, renewMonthItemParam)
            }
          })

          // 找出共同擁有的月租序號
          let validMonthNumbers = monthResponse.data.Data.map((element) => element.Number)

          // 刪除 RenewMonthItems 中不存在於 monthResponse.data.Data 的項目
          this.editedQuotation.RenewMonthItems = this.editedQuotation.RenewMonthItems.filter(
            (item) => validMonthNumbers.includes(item.MonthNumber)
          )
        }
      }
    },
    async searchMonthForOriginalLicensePlate () {
      if (this.editedQuotation.Type === this.quotationType.TypeRenew) {
        let param = {
          customerId: this.editedQuotation.OriginalCustomer.Id,
          licensePlate: this.editedQuotation.OriginalLicensePlate
        }
        this.editedQuotation.MonthItems = []
        let monthResponse = await HttpMonth.GetMonthList(param)
        if (monthResponse && monthResponse.status === 200) {
          monthResponse.data.Data.forEach((element) => {
            if (element.MonthStatus === 1) {
              let temp = {
                Id: element.ItemId,
                Number: element.ItemNumber,
                Name: element.ItemName,
                MonthNumber: element.Number,
                Unit: element.ItemUnit,
                DiscountPrice: element.OriginalCurrency * 1,
                Discount: 0,
                Quantity: element.OverageMonthQuantity * 1,
                RentQuantity: 1,
                Price: element.OriginalCurrency * 1,
                TotalPrice: element.OverageMonthQuantity * element.OriginalCurrency * 1,
                RentWarrantyPeriod: element.RentWarrantyPeriod * 1,
                PayType: element.PayType,
                Remark: element.Remark,
                PayTimeRangeType: element.PayTimeRangeType
              }
              this.editedQuotation.MonthItems.push(temp)
            }
          })
        }
      }
    },
    setRenewMonthTime (val) {
      this.editedQuotation.RenewMonthTime = val * 1
    },
    async getQuotationItemsTempStock () {
      let array = []
      this.editedQuotation.QuotationItems.forEach((element) => {
        if (element.Number) {
          array.push(element.Number)
        } else {
          element.BomItems.forEach((bomItem) => {
            array.push(bomItem.Number)
          })
        }
      })
      await this.getTempStockByItemsNumber(array)
    },
    async getTryInstallItemsTempStock () {
      let array = []
      this.editedQuotation.TryInstallItems.forEach((element) => {
        if (element.Number) {
          array.push(element.Number)
        } else {
          element.BomItems.forEach((bomItem) => {
            array.push(bomItem.Number)
          })
        }
      })
      await this.getTempStockByItemsNumber(array)
    },
    async getTempStockByItemsNumber (array) {
      let stringList = array.join(',')
      let response = await HttpTempStock.GetTempStockListByItemsNumber({
        itemsNumber: stringList
      })
      this.tempStockList = response && response.status === 200 ? response.data.Data : []
    },
    changeTaxType () {
      if (
        this.editedQuotation.Customer.InvoiceType * 1 ===
        this.invoiceType.DuplicateUniformInvoice
      ) {
        this.editedQuotation.Customer.TaxType = '1'
      } else {
        this.editedQuotation.Customer.TaxType = '2'
      }
    },
    async throwTryInstallNewInstallToSale () {
      this.editedQuotation.IsThrow = true
      this.editedQuotation.ThrowUsers.push({
        Name: this.getUserAccountId,
        ThrowTime: Date.parse(new Date())
      })
      let response = await HttpQuotation.ThrowTryInstallNewInstallToSale(this.editedQuotation)
      this.isSuccess = response && response.status === 200
      this.isQuotationThrow = true
      await this.searchEditQuotation()
    },
    setNumber () {
      this.editedQuotation.RepairNumber = ''
      this.editedQuotation.OffsetItems = []
      this.editedQuotation.FixNumber = ''
    },
    setRepairNumber (val) {
      if (val && val.Number) {
        this.editedQuotation.LicensePlate = val.LicensePlate
        this.editedQuotation.RepairNumber = val.Number
        this.editedQuotation.SaleNumber = val.SaleNumber
        this.editedQuotation.SaleType = val.SaleType
        val.RepairItems.forEach((element) => {
          if (element.ReturnItem) {
            this.editedQuotation.OffsetItems.push({
              BomId: element.ReturnItem.BomId,
              BomDescribe: element.ReturnItem.BomDescribe,
              BomName: element.ReturnItem.BomName,
              Id: element.ReturnItem.ItemId,
              Number: element.ReturnItem.Number,
              Name: element.ReturnItem.Name,
              Unit: element.ReturnItem.Unit,
              StoreNo: element.ReturnItem.StoreNo,
              Spec: element.ReturnItem.Spec,
              HasSerialNumber: element.ReturnItem.HasSerialNumber,
              Quantity: element.ReturnItem.RealQuantity,
              BuyOrRentType: element.ReturnItem.BuyOrRentType,
              SerialNumber: element.ReturnItem.SerialNumber,
              InstallPosition: element.ReturnItem.InstallPosition,
              IsCustomerDevice: element.ReturnItem.IsCustomerDevice,
              CustomerDeviceType: element.ReturnItem.CustomerDeviceType,
              Remark: element.ReturnItem.Remark,
              Price: element.ReturnItem.Price,
              TotalPrice: element.ReturnItem.Price * element.ReturnItem.RealQuantity,
              WarrantyPeriod: element.ReturnItem.WarrantyPeriod,
              RepairWarrantyPeriod: element.ReturnItem.RepairWarrantyPeriod,
              RepairPrice: element.ReturnItem.RepairPrice,
              DiscountPrice: element.ReturnItem.Price * element.ReturnItem.RealQuantity,
              Discount: 0,
              Type: element.ReturnItem.Type
            })
          }
        })
      } else {
        this.editedQuotation.RepairNumber = ''
        this.editedQuotation.SaleNumber = ''
        this.editedQuotation.SaleType = ''
        this.editedQuotation.OffsetItems = []
      }
    },
    setAcceptanceNumber (val) {
      if (val && val.Number) {
        this.editedQuotation.AcceptanceNumber = val.Number
        this.editedQuotation.LicensePlate = val.LicensePlate
      } else {
        this.editedQuotation.AcceptanceNumber = ''
      }
    },
    setFixNumber (val) {
      if (val && val.Number) {
        this.editedQuotation.FixNumber = val.Number
        this.editedQuotation.LicensePlate = val.LicensePlate
      } else {
        this.editedQuotation.FixNumber = ''
      }
    },
    setSpecifyStopTime (val) {
      this.editedQuotation.SpecifyStopTime = val * 1
    },
    isShowSelectMergeQuotationBtn () {
      this.$refs.selectMergeQuotation.isShowSelectMergeQuotationBtn()
    },
    async getAllPayType () {
      let response = await HttpMonth.GetAllPayType()
      this.allPayType = response.status === 200 ? response.data.Data : []
    },
    async transferToResume () {
      this.editedQuotation.IsThrowToResume = true
      if (this.editedQuotation.AcceptanceNumber) {
        await HttpQuotation.TransferAcceptanceToResume(this.editedQuotation)
      } else if (this.editedQuotation.RepairNumber) {
        await HttpQuotation.TransferRepairToResume(this.editedQuotation)
      }
    },
    openSelectTypeDialog () {
      if (!this.editedQuotation.Customer.Number) {
        this.editedCustomer.InvoiceType = this.editedQuotation.Customer.InvoiceType
        this.editedCustomer.CurrencyNo = this.editedQuotation.Customer.CurrencyNo
      } else {
        this.editedCustomer = JSON.parse(JSON.stringify(this.editedQuotation.Customer))
      }

      this.isShowSelectTypeDialog = true
    },
    closeThrowNewQuotationDialog () {
      this.editedCustomer = JSON.parse(JSON.stringify(this.defaultCustomer))
      this.selectedType = null
      this.isShowSelectTypeDialog = false
    },
    async throwProjectToQuotation () {
      this.editedQuotation.IsThrow = true
      this.editedQuotation.ThrowUsers.push({
        Name: this.getUserAccountId,
        ThrowTime: Date.parse(new Date())
      })
      let projectThrowData = {
        Quotation: this.editedQuotation,
        Customer: this.editedCustomer,
        SelectQuotationType: this.selectedType
      }
      this.isLoadingSelectType = true
      let response = await HttpQuotation.ThrowQuotation(projectThrowData)
      this.isLoadingSelectType = false
      this.isSuccess = response && response.status === 200
      this.isQuotationThrow = true
      if (this.isSuccess) {
        if (this.editedCustomer.Number !== this.editedQuotation.Customer.Number) {
          this.editedQuotation.RecordCustomer = JSON.parse(JSON.stringify(this.editedCustomer))
        }
        await HttpQuotation.UpdateQuotation(this.editedQuotation)
        await this.searchEditQuotation()
      }
    },
    async confirmThrowQuotation () {
      const isValid = await this.$refs.selectTypeDialog.validate()
      if (!isValid) {
        return
      }
      if (this.editedQuotation.Type === this.quotationType.TypeProject) {
        await this.throwProjectToQuotation()
      } else if (this.editedQuotation.Type === this.quotationType.TypeProjectPayItem) {
        await this.throwProjectPayItemToSale()
      }
      this.closeThrowNewQuotationDialog()
    },
    async throwQuotation () {
      this.editedQuotation.IsThrow = true
      this.editedQuotation.ThrowUsers.push({
        Name: this.getUserAccountId,
        ThrowTime: Date.parse(new Date())
      })
      let response = await HttpDivideQuotation.DivideQuotation(this.editedQuotation)
      this.isSuccess = response && response.status === 200
      this.isQuotationThrow = true
      await this.searchEditQuotation()
    },
    setPayDiscountPrice () {
      this.editedQuotation.PayDiscountPrice =
        this.editedQuotation.PayAmt - this.editedQuotation.PayDiscount
      this.computedAmt()
    },
    setItemDiscountPrice () {
      this.editedQuotation.ItemDiscountPrice =
        this.editedQuotation.ItemAmt - this.editedQuotation.ItemDiscount
      this.computedAmt()
    },
    async getCustomerOriginalLicenseLicensePlateList () {
      let param = {
        customerId: this.editedQuotation.OriginalCustomer.Id
      }
      let response = await HttpCustomerLicensePlateMapping.GetLicensePlateListByCustomerId(param)
      this.customerOriginalLicensePlateList = response.status === 200 ? response.data.Data : []
    },
    async getCustomerLicensePlateList () {
      let param = {
        customerId: this.editedQuotation.Customer.Id
      }
      let response = await HttpCustomerLicensePlateMapping.GetLicensePlateListByCustomerId(param)
      this.customerLicensePlateList = response.status === 200 ? response.data.Data : []
    },
    async setQuotationName () {
      this.editedQuotation.Name = this.editedQuotation.Type.Name
      this.editedQuotation.Type = this.editedQuotation.Type.Type
      this.editedQuotation.Customer = JSON.parse(JSON.stringify(this.defaultQuotation.Customer))
      this.editedQuotation.OriginalCustomer = JSON.parse(
        JSON.stringify(this.defaultQuotation.OriginalCustomer)
      )
      if (this.editedQuotation.Type === this.quotationType.TypeRemoveCar) {
        this.editedQuotation.RemovedReason = 1
      } else {
        this.editedQuotation.RemovedReason = 0
      }
      if (this.editedQuotation.Type === this.quotationType.TypeTryInstall) {
        this.editedQuotation.TryInstallTime = this.editedQuotation.ExpDate
        this.editedQuotation.ExpDate = 0
      } else if (this.editedQuotation.TryInstallTime) {
        this.editedQuotation.ExpDate = this.editedQuotation.TryInstallTime
        this.editedQuotation.TryInstallTime = 0
      }
      this.clearQuotationList()
      this.editedQuotation = JSON.parse(JSON.stringify(this.editedQuotation))

      await this.getCustomerOriginalLicenseLicensePlateList()
      await this.getCustomerLicensePlateList()
    },
    clearQuotationList () {
      this.editedQuotation.OriginalLicensePlate = ''
      this.editedQuotation.LicensePlate = ''
      this.editedQuotation.LicensePlateList = []
      this.editedQuotation.TryInstallItems = []
      this.editedQuotation.QuotationItems = []
      this.editedQuotation.MonthItems = []
      this.editedQuotation.RemovedItems = []
      this.editedQuotation.ReturnItems = []
      this.editedQuotation.MoveItems = []
      this.editedQuotation.MoveMonthItems = []
      this.editedQuotation.OffsetItems = []
      this.editedQuotation.DiscountItems = []
      this.editedQuotation.PayItems = []
    },
    setQuotationTerm () {
      this.editedQuotation.SelectQuotationTerm.Name = this.selectQuotationTerm.Name
      this.editedQuotation.SelectQuotationTerm.Type = this.selectQuotationTerm.Type
      this.editedQuotation.SelectQuotationTerm.Content = this.selectQuotationTerm.Content
    },
    setMonthStartTime (val) {
      this.editedQuotation.MonthStartTime = val * 1
    },
    async throwMonth () {
      this.editedQuotation.IsThrowMonth = true
      await HttpMonth.ThrowMonthFromQuotation(this.editedQuotation)
      if (this.editedQuotation.DiscountItems.length > 0) {
        await HttpDiscount.ThrowDiscountFromQuotation(this.editedQuotation)
        await HttpOverage.ThrowOverageFromQuotation(this.editedQuotation)
      }
      await HttpQuotation.UpdateQuotation(this.editedQuotation)
      await this.searchEditQuotation()
    },
    setCarQuantity () {
      if (
        typeof this.editedQuotation.LicensePlateList !== 'undefined' &&
        this.editedQuotation.LicensePlateList.length !== 0
      ) {
        this.editedQuotation.CarQuantity = this.editedQuotation.LicensePlateList.length
      } else {
        this.editedQuotation.CarQuantity = 1
      }
    },
    setTermAutocomplete (event) {
      this.$refs.termAutocomplete.isMenuActive = false
      this.$refs.termAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setRemovedReasonAutocomplete (event) {
      this.$refs.removedReasonAutocomplete.isMenuActive = false
      this.$refs.removedReasonAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setInvoiceTypeAutocomplete (event) {
      this.$refs.invoiceTypeAutocomplete.isMenuActive = false
      this.$refs.invoiceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setCurrencyNoAutocomplete (event) {
      this.$refs.currencyNoAutocomplete.isMenuActive = false
      this.$refs.currencyNoAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setTypeAutocomplete (event) {
      this.$refs.typeAutocomplete.isMenuActive = false
      this.$refs.typeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setKeyDownAutocomplete () {
      ///  儲存keydown之前的Roles
      this.tempSpecialNeedList = this.editedQuotation.SpecialNeedList
    },
    setKeyUpAutocomplete (event) {
      this.$refs.specialNeedAutocomplete.isMenuActive = false
      this.$refs.specialNeedAutocomplete.isFocused = false
      ///  塞回keydown之前的Roles  給KeyUp的Model editedUser.Roles
      this.editedQuotation.SpecialNeedList = this.tempSpecialNeedList
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    turnSpecialNeedName (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(element.Name)
          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    async getSpecialNeedList () {
      let response = await HttpSpecialNeed.GetSpecialNeed()
      this.allSpecialNeedList = response.status === 200 ? response.data.Data : []
    },
    async getCurrency () {
      let response = await HttpCmsmf.GetCurrency()
      this.currencyList = response.status === 200 ? response.data.Data : []
    },
    async getInvoiceType () {
      let response = await HttpQuotation.GetInvoiceType()
      this.invoiceList = response.status === 200 ? response.data.Data : []
    },
    isShowInvalidQuotationDialogBtn () {
      this.isShowInvalidQuotationDialog = true
    },
    async invalidQuotation () {
      this.editedQuotation.IsInvalid = true
      this.editedQuotation.InvalidReason = this.invalidReason
      await HttpQuotation.UpdateQuotation(this.editedQuotation)
      this.closeInvalidQuotationDialog()
      await this.searchEditQuotation()
    },
    closeInvalidQuotationDialog () {
      this.invalidReason = ''
      this.isShowInvalidQuotationDialog = false
    },
    setSignDate (val) {
      this.editedQuotation.SignDate = val * 1
    },
    setTryInstallTime (val) {
      this.editedQuotation.TryInstallTime = val * 1
    },
    setExpDate (val) {
      this.editedQuotation.ExpDate = val * 1
    },
    async setOriginalCustomer (val) {
      this.editedQuotation.OriginalCustomer = JSON.parse(JSON.stringify(val))

      if (
        this.editedQuotation.Type === this.quotationType.TypeReturnCar ||
        this.editedQuotation.Type === this.quotationType.TypeMove
      ) {
        this.setCustomer(val)
        if (this.editedQuotation.Type === this.quotationType.TypeMove) {
          this.editedQuotation.OriginalCustomer.CurrencyNo = ''
        }
      } else {
        await this.searchResumeMonthForLicensePlate()
        await this.searchResumeMonthForOriginalLicensePlate()
      }
    },
    async setThrowCustomer (val) {
      this.editedCustomer = JSON.parse(JSON.stringify(val))
      this.editedCustomer.InvoiceType = this.editedQuotation.Customer.InvoiceType
      this.editedCustomer.CurrencyNo = this.editedQuotation.Customer.CurrencyNo
    },
    async setCustomer (val) {
      this.editedQuotation.Customer = JSON.parse(JSON.stringify(val))
      this.editedQuotation.Customer.CurrencyNo = ''
      await this.searchResumeMonthForLicensePlate()
      await this.searchResumeMonthForOriginalLicensePlate()
    },
    async setFilterCustomer (val) {
      this.filterQuotation.CustomerId = val.Id
      this.filterQuotation = JSON.parse(JSON.stringify(this.filterQuotation))
      this.onFilterChange()
    },
    async getRemoveReason () {
      let response = await HttpQuotation.GetRemoveReasonTypes()
      this.allRemovedReason = response.status === 200 ? response.data.Data : []
    },
    async getCustomerDetail () {
      let licensePlate =
        this.editedQuotation.Type === this.quotationType.TypeReturnCar ||
        this.editedQuotation.Type === this.quotationType.TypeMove
          ? this.editedQuotation.OriginalLicensePlate
          : this.editedQuotation.LicensePlate
      if (typeof licensePlate !== 'string' && licensePlate) {
        let customerResponse = await HttpCustomer.GetCustomerByNumber({
          number: licensePlate.CustomerNumber
        })
        if (customerResponse && customerResponse.status === 200) {
          this.editedQuotation.Customer = JSON.parse(JSON.stringify(customerResponse.data.Data))
        }
        if (
          this.editedQuotation.Type === this.quotationType.TypeReturnCar ||
          this.editedQuotation.Type === this.quotationType.TypeMove
        ) {
          this.editedQuotation.OriginalLicensePlate = licensePlate.LicensePlate
        } else {
          this.editedQuotation.LicensePlate = licensePlate.LicensePlate
        }
      }
    },
    async searchResumeMonthForLicensePlate () {
      await this.getCustomerDetail()
      if (this.editedQuotation.Type === this.quotationType.TypeRemoveCar) {
        let param = {
          customerId: this.editedQuotation.Customer.Id,
          licensePlate: this.editedQuotation.LicensePlate
        }
        let itemResponse = await HttpResume.GetOneResume(param)
        if (itemResponse && itemResponse.status === 200) {
          this.editedQuotation.RemovedItems = []
          this.editedQuotation.Brand = itemResponse.data.Data.Brand
          itemResponse.data.Data.ResumeItems.forEach((element) => {
            if (!element.IsRemoved) {
              element.Id = element.ItemId
              this.editedQuotation.RemovedItems.push(element)
            }
          })
        }

        let monthResponse = await HttpMonth.GetMonthList(param)
        let tempMonthItems = this.editedQuotation.MonthItems
        if (monthResponse && monthResponse.status === 200) {
          this.editedQuotation.MonthItems = []
          monthResponse.data.Data.forEach((element) => {
            if (element.MonthStatus === this.monthStatus.InProgress) {
              let temp = {
                Id: element.ItemId,
                Number: element.ItemNumber,
                Name: element.ItemName,
                MonthNumber: element.Number,
                Unit: element.ItemUnit,
                DiscountPrice: element.OriginalCurrency * 1,
                Discount: 0,
                Quantity: element.OverageMonthQuantity * 1,
                PayQuantity: element.PayQuantity * 1,
                RentQuantity: 1,
                StopPayQuantity: 0,
                AddPayQuantity: 0,
                Price: element.OriginalCurrency * 1,
                TotalPrice: element.OverageMonthQuantity * element.OriginalCurrency * 1,
                RentWarrantyPeriod: element.RentWarrantyPeriod * 1,
                PayType: element.PayType,
                Remark: element.Remark,
                PayTimeRangeType: element.PayTimeRangeType,
                PayQuantityType: element.PayQuantityType
              }
              this.editedQuotation.MonthItems.push(temp)
            }
          })
        }
        if (tempMonthItems.length > 0 && this.editedQuotation.MonthItems.length === 0) {
          this.editedQuotation.MonthItems = tempMonthItems
          this.editedQuotation.MonthItems.forEach((element) => {
            element.MonthNumber = ''
          })
        }
      } else if (this.editedQuotation.Type === this.quotationType.TypeRepair) {
        let param = {
          customerId: this.editedQuotation.Customer.Id,
          licensePlate: this.editedQuotation.LicensePlate
        }
        let itemResponse = await HttpResume.GetOneResume(param)
        if (itemResponse && itemResponse.status === 200) {
          this.editedQuotation.OffsetItems = []
          this.editedQuotation.Brand = itemResponse.data.Data.Brand
          itemResponse.data.Data.ResumeItems.forEach((element) => {
            element.Id = element.ItemId
            element.Price = 0
            element.Discount = 0
            element.DiscountPrice = 0
            element.TotalPrice = element.Quantity * element.Price
            element.WarrantyPeriod = 0
            element.RepairWarrantyPeriod = 0
            element.RepairPrice = 0
            this.editedQuotation.OffsetItems.push(element)
          })
        }
      }
    },
    async searchResumeMonthForOriginalLicensePlate () {
      await this.getCustomerDetail()
      if (this.editedQuotation.Type === this.quotationType.TypeReturnCar) {
        let param = {
          customerId: this.editedQuotation.OriginalCustomer.Id,
          licensePlate: this.editedQuotation.OriginalLicensePlate
        }
        let itemResponse = await HttpResume.GetOneResume(param)
        if (itemResponse && itemResponse.status === 200) {
          this.editedQuotation.ReturnItems = []
          this.editedQuotation.Brand = itemResponse.data.Data.Brand
          this.editedQuotation.SpecialNeedList = itemResponse.data.Data.SpecialNeedList
          itemResponse.data.Data.ResumeItems.forEach((element) => {
            if (element.IsRemoved) {
              element.Id = element.ItemId
              this.editedQuotation.ReturnItems.push(element)
            }
          })
        }

        let monthResponse = await HttpMonth.GetMonthList(param)
        let tempMonthItems = this.editedQuotation.MonthItems
        if (monthResponse && monthResponse.status === 200) {
          this.editedQuotation.MonthItems = []
          monthResponse.data.Data.forEach((element) => {
            if (element.MonthStatus === this.monthStatus.Stop) {
              let temp = {
                Id: element.ItemId,
                Number: element.ItemNumber,
                Name: element.ItemName,
                MonthNumber: element.Number,
                Unit: element.ItemUnit,
                DiscountPrice: element.OriginalCurrency * 1,
                Discount: 0,
                Quantity: element.OverageMonthQuantity * 1,
                PayQuantity: element.PayQuantity * 1,
                StopPayQuantity: 0,
                AddPayQuantity: 0,
                RentQuantity: 1,
                Price: element.OriginalCurrency * 1,
                TotalPrice: element.OverageMonthQuantity * element.OriginalCurrency * 1,
                RentWarrantyPeriod: element.RentWarrantyPeriod * 1,
                PayType: element.PayType,
                Remark: element.Remark,
                PayTimeRangeType: element.PayTimeRangeType,
                PayQuantityType: element.PayQuantityType
              }
              this.editedQuotation.MonthItems.push(temp)
            }
          })
          this.computedAmt()
        }
        if (tempMonthItems.length > 0 && this.editedQuotation.MonthItems.length === 0) {
          this.editedQuotation.MonthItems = tempMonthItems
          this.editedQuotation.MonthItems.forEach((element) => {
            element.MonthNumber = ''
          })
        }
      } else if (this.editedQuotation.Type === this.quotationType.TypeMove) {
        let param = {
          customerId: this.editedQuotation.OriginalCustomer.Id,
          licensePlate: this.editedQuotation.OriginalLicensePlate
        }
        let itemResponse = await HttpResume.GetOneResume(param)
        if (itemResponse && itemResponse.status === 200) {
          this.editedQuotation.MoveItems = []
          this.editedQuotation.Brand = itemResponse.data.Data.Brand
          this.editedQuotation.SpecialNeedList = itemResponse.data.Data.SpecialNeedList
          itemResponse.data.Data.ResumeItems.forEach((element) => {
            if (!element.IsRemoved) {
              element.Id = element.ItemId
              element.RemoveQuantity = 1
              element.ReturnQuantity = 1
              this.editedQuotation.MoveItems.push(element)
            }
          })
        }

        let monthResponse = await HttpMonth.GetMonthList(param)
        let tempMoveMonthItems = this.editedQuotation.MoveMonthItems

        if (monthResponse && monthResponse.status === 200) {
          this.editedQuotation.MoveMonthItems = []
          monthResponse.data.Data.forEach((element) => {
            if (element.MonthStatus === this.monthStatus.InProgress) {
              let temp = {
                Id: element.ItemId,
                Number: element.ItemNumber,
                Name: element.ItemName,
                MonthNumber: element.Number,
                Unit: element.ItemUnit,
                DiscountPrice: element.OriginalCurrency * 1,
                Discount: 0,
                PayQuantity: element.PayQuantity * 1,
                StopPayQuantity: 0,
                AddPayQuantity: 0,
                Quantity: element.OverageMonthQuantity * 1,
                RemoveQuantity: 1,
                ReturnQuantity: 1,
                Price: element.OriginalCurrency * 1,
                TotalPrice: element.OverageMonthQuantity * element.OriginalCurrency * 1,
                RentWarrantyPeriod: element.RentWarrantyPeriod * 1,
                PayType: element.PayType,
                Remark: element.Remark,
                PayTimeRangeType: element.PayTimeRangeType,
                PayQuantityType: element.PayQuantityType
              }
              this.editedQuotation.MoveMonthItems.push(temp)
            }
          })
          this.computedAmt()
        }
        if (tempMoveMonthItems.length > 0 && this.editedQuotation.MoveMonthItems.length === 0) {
          this.editedQuotation.MoveMonthItems = tempMoveMonthItems
          this.editedQuotation.MoveMonthItems.forEach((element) => {
            element.MonthNumber = ''
          })
        }
      }
    },
    async getQuotationTerm () {
      let response = await HttpQuotation.GetQuotationTerm()
      this.allQuotationTerms = response.status === 200 ? response.data.Data : []
    },
    methodsStatus (value) {
      if (value.IsDone) {
        return '已結案'
      } else if (value.IsInvalid) {
        return this.$t('quotation_invalid_status')
      } else if (value.IsConfirmQuotation && !value.IsExportQuotation) {
        return this.$t('quotation_tool_confirm_quotation_btn')
      } else if (value.IsExportQuotation && !value.IsConfirm && value.FileDoneTime === 0) {
        return this.$t('quotation_export_status')
      } else if (!value.IsConfirm && value.FileDoneTime !== 0) {
        return this.$t('quotation_upload_status')
      } else if (
        value.IsConfirm &&
        !value.IsThrowTransferOrder &&
        !value.IsInvalid &&
        !value.IsThrowMonth
      ) {
        return this.$t('quotation_tool_confirm_btn')
      } else if (
        value.IsThrowTransferOrder &&
        !value.IsThrow &&
        !value.IsInvalid &&
        !value.IsThrowMonth
      ) {
        return '已拋轉倉管核對'
      } else if (value.IsThrow) {
        return this.$t('quotation_throw_status')
      } else if (value.IsThrowMonth) {
        return '已拋轉月租'
      } else {
        return this.$t('quotation_tool_not_confirm_quotation_btn')
      }
    },
    async isOpenQuotation () {
      await this.getNumber()
      this.editedQuotation.Number = this.quotationNumber
      this.isShowEditQuotationDialog = true
    },
    async getNumber () {
      this.editedQuotation.CreateTime = Date.parse(new Date())
      let response = await HttpQuotation.MakeNumber()
      this.quotationNumber = response.status === 200 ? response.data.Data : ''
    },
    async checkRepairQuotationIsExist () {
      if (!this.errorMessage && this.editedQuotation.Type === this.quotationType.TypeRepair) {
        let response = await HttpQuotation.CheckRepairQuotationIsExist(this.editedQuotation)
        let checkQuotation = response && response.status === 200 ? response.data.Data : {}
        if (checkQuotation && checkQuotation.IsExist) {
          this.existErrorMessage = checkQuotation.Message
          alert(this.existErrorMessage)
        } else {
          this.existErrorMessage = ''
        }
      } else {
        this.existErrorMessage = ''
      }
    },
    async checkHasRepairPrice () {
      if (this.editedQuotation.Type !== this.quotationType.TypeMonth) {
        let response = await HttpQuotation.CheckHasRepairPrice(this.editedQuotation)
        let quotationErrorMessageObj = response && response.status === 200 ? response.data.Data : {}
        if (quotationErrorMessageObj && quotationErrorMessageObj.Quotation) {
          if (quotationErrorMessageObj.ErrorMessage) {
            this.errorMessage = quotationErrorMessageObj.ErrorMessage
            alert(this.errorMessage)
          } else {
            this.errorMessage = ''
          }
          this.editedQuotation = JSON.parse(JSON.stringify(quotationErrorMessageObj.Quotation))
        }
      } else {
        this.errorMessage = ''
      }
    },
    async copyQuotation () {
      // copy時單號寫到CopyNumber
      await this.checkHasRepairPrice()
      this.editedQuotationIndex = -1
      this.isAllTextFieldDisabled = false

      this.isCopy = true
      this.fileDate = ''
      this.editedQuotation.Id = ''
      this.editedQuotation.IsConfirm = false
      this.editedQuotation.IsConfirmQuotation = false
      this.editedQuotation.IsExportQuotation = false
      this.editedQuotation.IsThrow = false
      this.editedQuotation.CreateTime = 0
      this.editedQuotation.SignDate = 0
      this.editedQuotation.Accessory = ''
      this.editedQuotation.ExpDate = 0
      this.editedQuotation.ErpType = ''
      this.editedQuotation.ErpNumber = ''
      this.editedQuotation.FixType = 0
      this.editedQuotation.FixNumber = ''
      this.editedQuotation.NoticeType = 0
      this.editedQuotation.NoticeNumber = ''
      this.editedQuotation.CreateBy = ''
      this.editedQuotation.ThrowUsers = []
      this.editedQuotation.FileDoneTime = 0
      this.editedQuotation.IsInvalid = false
      this.editedQuotation.InvalidTime = 0
      this.editedQuotation.InvalidBy = ''
      this.editedQuotation.LicensePlateList = []
      this.editedQuotation.OriginalLicensePlate = ''
      this.editedQuotation.LicensePlate = ''
      this.editedQuotation.MonthStartTime = 0
      this.editedQuotation.RenewMonthTime = 0
      this.editedQuotation.OriginalNumber = ''
      this.editedQuotation.SaleType = ''
      this.editedQuotation.SaleNumber = ''
      this.editedQuotation.AcceptanceNoticeType = 0
      this.editedQuotation.AcceptanceNumber = ''
      this.editedQuotation.RepairNumber = ''
      this.editedQuotation.IsDone = false
      this.editedQuotation.IsThrowToResume = false
      this.editedQuotation.UpdateBy = ''
      this.editedQuotation.UpdateTime = 0
      this.editedQuotation.ReviewBy = ''
      this.editedQuotation.ReviewTime = 0
      this.editedQuotation.IsDelete = false
      this.editedQuotation.NumberType = 0
      this.editedQuotation.TryInstallTime = 0
      this.editedQuotation.OriginalTryInstallNumber = ''
      this.editedQuotation.CopyNumber = this.editedQuotation.Number
      await this.getNumber()
      this.editedQuotation.Number = this.quotationNumber
      if (this.editedQuotation.DiscountItems && this.editedQuotation.DiscountItems.length > 0) {
        let discountItems = this.editedQuotation.DiscountItems
        let discountIdMap = new Map()

        // 重新產生 DiscountId
        discountItems.forEach((item) => {
          let oldId = item.DiscountId
          let newId = this.generateObjectId()

          discountIdMap.set(oldId, newId)
          item.DiscountId = newId
        })

        // 更新 WaitForDiscountIds
        discountItems.forEach((item) => {
          if (item.WaitForDiscountIds && item.WaitForDiscountIds.length > 0) {
            item.WaitForDiscountIds = item.WaitForDiscountIds.map(
              (id) => discountIdMap.get(id) ?? id
            )
          }
        })
      }
      this.computedAmt()
    },
    async transferToSale () {
      this.editedQuotation.IsThrow = true
      this.isLoadingQuotation = true
      this.editedQuotation.ThrowUsers.push({
        Name: this.getUserAccountId,
        ThrowTime: Date.parse(new Date())
      })

      let response = await HttpQuotation.TransferToSale(this.editedQuotation)
      this.isSuccess = response && response.status === 200
      this.isQuotationThrow = true
      this.isLoadingQuotation = false
      await this.searchEditQuotation()
    },
    closeUploadDialog () {
      this.isUploadDialog = false
    },
    async saveUploadDialogRemark () {
      await HttpFile.FileUploadRecord(this.uploadRecord)
      await HttpQuotation.UpdateQuotation(this.editedQuotation)
      await this.searchEditQuotation()
      this.closeUploadDialog()
      this.$refs.file.click()
    },
    openFileDialog () {
      if (this.editedQuotation.Accessory === '') {
        this.$refs.file.click()
      } else {
        this.uploadRecord.Accessory = this.editedQuotation.Accessory
        this.uploadRecord.Type = this.editedQuotation.Type
        this.uploadRecord.Number = this.editedQuotation.Number
        this.uploadRecord.AccessoryRemark = ''
        this.isUploadDialog = true
      }
    },
    async searchEditQuotation () {
      let param = {
        number: this.editedQuotation.Number,
        type: this.editedQuotation.Type
      }
      let response = await HttpQuotation.SearchEditedQuotation(param)
      this.editedQuotation = response.status === 200 ? response.data.Data : []
    },
    async uploadQuotation (event) {
      if (event.target.files.length > 0) {
        this.ImportExcelFile = event.target.files[0]
        this.editedQuotation.Accessory = this.ImportExcelFile.name
        var excelFile = this.ImportExcelFile
        let formData = new FormData()
        formData.append('File', excelFile)
        formData.append('Type', this.editedQuotation.Type)
        formData.append('SignDate', this.editedQuotation.SignDate)
        await HttpFile.UploadFile(formData)
        this.editedQuotation.FileDoneTime = Date.parse(new Date())
        await HttpQuotation.UpdateQuotation(this.editedQuotation)
        this.fileDate = ''
        await this.searchEditQuotation()
      }
    },
    async downloadUploadFile () {
      let response = await HttpFile.DownloadFile(this.editedQuotation)
      const aEle = document.createElement('a') // 創建a標籤
      const href = window.URL.createObjectURL(response.data) // 創建下載的鏈接
      aEle.href = href
      aEle.download = this.editedQuotation.Accessory // 下載後文件名
      document.body.appendChild(aEle)
      aEle.click() // 點擊下載
      document.body.removeChild(aEle) // 下載完成移除元素
      window.URL.revokeObjectURL(href) // 釋放掉blob對象
    },
    // isPreview=true 代表簽核前預覽，檔名加上 預覽_ 前綴
    async exportOffsetQuotation (isPreview = false) {
      let response = await HttpQuotation.ExportOffsetQuotation(this.editedQuotation, isPreview)

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const aEle = document.createElement('a') // 創建a標籤
        const href = window.URL.createObjectURL(blob) // 創建下載的鏈接
        aEle.href = href
        let type = ''
        if (this.editedQuotation.Type === this.quotationType.TypeRepair) {
          type = '維修_'
        } else if (this.editedQuotation.Type === this.quotationType.TypeOffset) {
          type = '補單_'
        }
        aEle.download =
          (isPreview ? '預覽_' : '') +
          type +
          this.editedQuotation.Number +
          '_' +
          this.editedQuotation.Customer.ShortName.slice(0, 4) +
          '_' +
          this.$moment(this.editedQuotation.CreateTime).format('YYYYMMDD_HHmmss') +
          '.xlsx' // 下載後文件名
        document.body.appendChild(aEle)
        aEle.click() // 點擊下載
        document.body.removeChild(aEle) // 下載完成移除元素
        window.URL.revokeObjectURL(href) // 釋放掉blob對象
      }
      if (!isPreview) await this.searchEditQuotation()
    },
    // isPreview=true 代表簽核前預覽，檔名加上 預覽_ 前綴
    async exportProjectPayItemQuotation (isPreview = false) {
      let response = await HttpQuotation.ExportProjectPayItemQuotation(
        this.editedQuotation,
        isPreview
      )

      if (response && response.status === 200) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const aEle = document.createElement('a') // 創建a標籤
        const href = window.URL.createObjectURL(blob) // 創建下載的鏈接
        aEle.href = href
        aEle.download =
          (isPreview ? '預覽_' : '') +
          '軟體開發_' +
          this.editedQuotation.Number +
          '_' +
          this.editedQuotation.Customer.ShortName.slice(0, 4) +
          '_' +
          this.$moment(this.editedQuotation.CreateTime).format('YYYYMMDD_HHmmss') +
          '.xlsx' // 下載後文件名
        document.body.appendChild(aEle)
        aEle.click() // 點擊下載
        document.body.removeChild(aEle) // 下載完成移除元素
        window.URL.revokeObjectURL(href) // 釋放掉blob對象
      }
      if (!isPreview) await this.searchEditQuotation()
    },
    // isPreview=true 代表簽核前預覽，檔名加上 預覽_ 前綴
    async exportInstallQuotation (isPreview = false) {
      let response = await HttpQuotation.ExportInstallQuotation(this.editedQuotation, isPreview)

      if (response && response.status === 200) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const aEle = document.createElement('a') // 創建a標籤
        const href = window.URL.createObjectURL(blob) // 創建下載的鏈接
        aEle.href = href
        let type = ''
        if (this.editedQuotation.Type === this.quotationType.TypeNewInstall) {
          type = '新裝機_'
        } else if (this.editedQuotation.Type === this.quotationType.TypeMonth) {
          type = '月租_'
        } else if (this.editedQuotation.Type === this.quotationType.TypeProject) {
          type = '專案_'
        }
        aEle.download =
          (isPreview ? '預覽_' : '') +
          type +
          this.editedQuotation.Number +
          '_' +
          this.editedQuotation.Customer.ShortName.slice(0, 4) +
          '_' +
          this.$moment(this.editedQuotation.CreateTime).format('YYYYMMDD_HHmmss') +
          '.xlsx' // 下載後文件名
        document.body.appendChild(aEle)
        aEle.click() // 點擊下載
        document.body.removeChild(aEle) // 下載完成移除元素
        window.URL.revokeObjectURL(href) // 釋放掉blob對象
      }
      if (!isPreview) await this.searchEditQuotation()
    },
    // isPreview=true 代表簽核前預覽，檔名加上 預覽_ 前綴
    async exportRemoveQuotation (isPreview = false) {
      let response = await HttpQuotation.ExportRemoveQuotation(this.editedQuotation, isPreview)

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const aEle = document.createElement('a') // 創建a標籤
        const href = window.URL.createObjectURL(blob) // 創建下載的鏈接
        aEle.href = href
        aEle.download =
          (isPreview ? '預覽_' : '') +
          '拆機_' +
          this.editedQuotation.Number +
          '_' +
          this.editedQuotation.Customer.ShortName.slice(0, 4) +
          '_' +
          this.$moment(this.editedQuotation.CreateTime).format('YYYYMMDD_HHmmss') +
          '.xlsx' // 下載後文件名
        document.body.appendChild(aEle)
        aEle.click() // 點擊下載
        document.body.removeChild(aEle) // 下載完成移除元素
        window.URL.revokeObjectURL(href) // 釋放掉blob對象
      }
      if (!isPreview) await this.searchEditQuotation()
    },
    // isPreview=true 代表簽核前預覽，檔名加上 預覽_ 前綴
    async exportMoveQuotation (isPreview = false) {
      let response = await HttpQuotation.ExportMoveQuotation(this.editedQuotation, isPreview)
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const aEle = document.createElement('a') // 創建a標籤
        const href = window.URL.createObjectURL(blob) // 創建下載的鏈接
        aEle.href = href
        aEle.download =
          (isPreview ? '預覽_' : '') +
          '移機_' +
          this.editedQuotation.Number +
          '_' +
          this.editedQuotation.Customer.ShortName.slice(0, 4) +
          '_' +
          this.$moment(this.editedQuotation.CreateTime).format('YYYYMMDD_HHmmss') +
          '.xlsx' // 下載後文件名
        document.body.appendChild(aEle)
        aEle.click() // 點擊下載
        document.body.removeChild(aEle) // 下載完成移除元素
        window.URL.revokeObjectURL(href) // 釋放掉blob對象
      }
      if (!isPreview) await this.searchEditQuotation()
    },
    // isPreview=true 代表簽核前預覽，檔名加上 預覽_ 前綴
    async exportReturnQuotation (isPreview = false) {
      let response = await HttpQuotation.ExportReturnQuotation(this.editedQuotation, isPreview)

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const aEle = document.createElement('a') // 創建a標籤
        const href = window.URL.createObjectURL(blob) // 創建下載的鏈接
        aEle.href = href
        aEle.download =
          (isPreview ? '預覽_' : '') +
          '回裝_' +
          this.editedQuotation.Number +
          '_' +
          this.editedQuotation.Customer.ShortName.slice(0, 4) +
          '_' +
          this.$moment(this.editedQuotation.CreateTime).format('YYYYMMDD_HHmmss') +
          '.xlsx' // 下載後文件名
        document.body.appendChild(aEle)
        aEle.click() // 點擊下載
        document.body.removeChild(aEle) // 下載完成移除元素
        window.URL.revokeObjectURL(href) // 釋放掉blob對象
      }
      if (!isPreview) await this.searchEditQuotation()
    },
    cancelEditBtn () {
      this.isAllTextFieldDisabled = true
      let str = JSON.stringify(this.tempQuotation)
      this.editedQuotation = JSON.parse(str)
    },
    async isConfirmBtn () {
      const isValid = await this.$refs.dialog.validate()
      if (!isValid) {
        alert('請確認必填欄位是否已正確填寫（標示 * 的欄位為必填）')
        return
      }
      this.isAllTextFieldDisabled = true
      this.editedQuotation.IsConfirm = true
      await HttpQuotation.UpdateQuotation(this.editedQuotation)
      await HttpTempStock.UpdateCurrentQuantityFromQuotation(this.editedQuotation)
      await this.getStockFlow()
      await this.searchEditQuotation()
    },
    async isConfirmQuotationBtn () {
      // 條款內容為空時禁止簽核
      if (!this.checkQuotationTerm()) return
      // 品項需同時包含授權(SU)與門號(VC)
      if (!this.checkAuthAndPhoneItems()) return
      await this.checkHasRepairPrice()
      this.checkQuantity()
      if (!this.errorMessage && !this.existErrorMessage && !this.quantityErrorMessage) {
        const isValid = await this.$refs.dialog.validate()
        if (!isValid) {
          alert('請確認必填欄位是否已正確填寫（標示 * 的欄位為必填）')
          return
        }
        this.isAllTextFieldDisabled = true
        this.editedQuotation.IsConfirmQuotation = true
        await HttpQuotation.UpdateQuotation(this.editedQuotation)
        await this.searchEditQuotation()
      }
    },
    // 批量輸入車牌後同步原本 @change 會觸發的邏輯
    onBatchInputLicensePlate (newList) {
      this.editedQuotation.LicensePlateList = newList
      this.setCarQuantity()
      this.searchMonthForLicensePlate()
    },
    // 檢查報價單條款內容是否存在，條款為空時禁止儲存或簽核
    checkQuotationTerm () {
      const term = this.editedQuotation.SelectQuotationTerm
      if (!term || !term.Content || term.Content.trim() === '') {
        alert('報價單條款內容為空，請先選擇條款後再儲存或簽核')
        return false
      }
      return true
    },
    // 檢查品項中是否同時包含授權(SU)與門號(VC)
    // 各類型對應掃描的品項陣列：
    //   新裝 TypeNewInstall → QuotationItems
    //   回裝 TypeReturnCar  → QuotationItems(新加裝) + ReturnItems
    //   拆機 TypeRemoveCar  → RemovedItems
    //   移機 TypeMove       → MoveItems
    //   專案 TypeProject    → QuotationItems
    //   試裝 TypeTryInstall → TryInstallItems
    // 其他類型不檢查，直接通過
    // 若缺少 SU 或 VC 品項，跳 confirm 提醒但允許使用者選擇繼續儲存
    checkAuthAndPhoneItems () {
      const q = this.editedQuotation
      const qt = this.quotationType
      let itemLists = []
      switch (q.Type) {
        case qt.TypeNewInstall:
          itemLists = [q.QuotationItems]
          break
        case qt.TypeReturnCar:
          itemLists = [q.QuotationItems, q.ReturnItems]
          break
        case qt.TypeRemoveCar:
          itemLists = [q.RemovedItems]
          break
        case qt.TypeMove:
          itemLists = [q.MoveItems]
          break
        case qt.TypeProject:
          itemLists = [q.QuotationItems]
          break
        case qt.TypeTryInstall:
          itemLists = [q.TryInstallItems]
          break
        default:
          return true
      }
      let hasAuth = false
      let hasPhone = false
      for (const list of itemLists) {
        if (!Array.isArray(list)) continue
        for (const item of list) {
          if (item && item.Number) {
            if (item.Number.startsWith('SU')) hasAuth = true
            if (item.Number.startsWith('VC')) hasPhone = true
          }
          if (item && Array.isArray(item.BomItems)) {
            for (const bom of item.BomItems) {
              if (bom && bom.Number) {
                if (bom.Number.startsWith('SU')) hasAuth = true
                if (bom.Number.startsWith('VC')) hasPhone = true
              }
            }
          }
          if (hasAuth && hasPhone) return true
        }
      }
      if (!hasAuth || !hasPhone) {
        return confirm('品項中缺少授權(SU開頭)或門號(VC開頭)，確定要繼續儲存嗎？')
      }
      return true
    },
    checkQuantity () {
      if (
        !this.errorMessage &&
        !this.existErrorMessage &&
        (this.editedQuotation.Type === this.quotationType.TypeNewInstall ||
          this.editedQuotation.Type === this.quotationType.TypeProject)
      ) {
        this.editedQuotation.QuotationItems.forEach((element) => {
          let totalQuantity = element.BuyQuantity * 1 + element.RentQuantity * 1
          if (totalQuantity === 0) {
            this.quantityErrorMessage = '請輸入買斷、公司提供數量'
            return false // 中斷迴圈
          } else if (totalQuantity > this.editedQuotation.CarQuantity * 1) {
            this.quantityErrorMessage = '買斷、公司提供數量不正確'
            return false // 中斷迴圈
          }
        })
        if (this.quantityErrorMessage) {
          alert(this.quantityErrorMessage)
        } else {
          this.quantityErrorMessage = ''
        }
      }
    },
    hardwareItems (item) {
      if (!item) return []
      if (item.QuotationItems && item.QuotationItems.length) return item.QuotationItems
      if (item.OffsetItems && item.OffsetItems.length) return item.OffsetItems
      if (item.RemovedItems && item.RemovedItems.length) return item.RemovedItems
      return []
    },
    hasHardwareItems (item) {
      return this.hardwareItems(item).length > 0
    },
    signDateStartTimestamp () {
      if (!this.filterQuotation.SignDateStart) return 0
      return this.$moment(this.filterQuotation.SignDateStart, 'YYYY-MM-DD')
        .startOf('day')
        .valueOf()
    },
    signDateEndTimestamp () {
      if (!this.filterQuotation.SignDateEnd) return 0
      return this.$moment(this.filterQuotation.SignDateEnd, 'YYYY-MM-DD')
        .endOf('day')
        .valueOf()
    },
    onSignDateStartChange (val) {
      this.filterQuotation.SignDateStart = val
      this.signDateStartMenu = false
      this.onFilterChange()
    },
    onSignDateEndChange (val) {
      this.filterQuotation.SignDateEnd = val
      this.signDateEndMenu = false
      this.onFilterChange()
    },
    clearSignDateStart () {
      this.filterQuotation.SignDateStart = ''
      this.onFilterChange()
    },
    clearSignDateEnd () {
      this.filterQuotation.SignDateEnd = ''
      this.onFilterChange()
    },
    onFilterChange () {
      this.currentOptions.page = 1
      this.isUpdateEventTotal = true
      this.getAllQuotation(this.currentOptions)
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getAllQuotation(val)
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          Number: this.filterQuotation.Number,
          Type: this.filterQuotation.Type,
          CustomerId: this.filterQuotation.CustomerId,
          LicensePlate: this.filterQuotation.LicensePlate,
          OriginalLicensePlate: this.filterQuotation.OriginalLicensePlate,
          Subject: this.filterQuotation.Subject,
          SpecialNeedId: this.filterQuotation.SpecialNeedId,
          SignDateStart: this.signDateStartTimestamp(),
          SignDateEnd: this.signDateEndTimestamp()
        }
        if (this.countTotalRowsSource) {
          this.countTotalRowsSource.cancel('cancel')
        }
        let cancelToken = axios.CancelToken
        this.countTotalRowsSource = cancelToken.source()
        let response = await HttpQuotation.GetAllQuotationCount(
          param,
          this.countTotalRowsSource.token
        )
        if (response) {
          this.totalRows = response.status === 200 ? response.data.Data : 0
        }
      }
    },
    turnTypeName (type) {
      return QuotationType.getQuotationTypeName(type)
    },
    async getAllQuotationType () {
      this.isLoadingQuotation = true
      if (this.quotationTypesSource) {
        this.quotationTypesSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.quotationTypesSource = cancelToken.source()
      let response = await HttpQuotation.GetAllQuotationTypes(this.quotationTypesSource.token)
      this.isLoadingQuotation = false
      if (response) {
        this.allQuotationType = response.status === 200 ? response.data.Data : []
        this.quotationTypesSource = null
      }
    },
    async getAllQuotation (val) {
      const o = val && Array.isArray(val.sortBy) ? val : this.currentOptions

      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isLoadingQuotation = true

      const param = {
        Number: this.filterQuotation.Number,
        Type: this.filterQuotation.Type,
        CustomerId: this.filterQuotation.CustomerId,
        LicensePlate: this.filterQuotation.LicensePlate,
        OriginalLicensePlate: this.filterQuotation.OriginalLicensePlate,
        Subject: this.filterQuotation.Subject,
        SpecialNeedId: this.filterQuotation.SpecialNeedId,
        ItemsPerPage: o.itemsPerPage,
        Page: o.page,
        SortBy: o.sortBy[0] || 'CreateTime',
        SortDesc: o.sortDesc.length ? o.sortDesc[0] : true,
        SignDateStart: this.signDateStartTimestamp(),
        SignDateEnd: this.signDateEndTimestamp()
      }

      if (this.quotationSource) {
        this.quotationSource.cancel('cancel')
      }
      const cancelToken = axios.CancelToken
      this.quotationSource = cancelToken.source()
      const response = await HttpQuotation.GetAllQuotations(param, this.quotationSource.token)
      this.isLoadingQuotation = false
      if (response) {
        this.quotationList = response.status === 200 ? response.data.Data : []
        this.quotationSource = null
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    async isShowEditQuotationDialogBtn (item) {
      this.isAllTextFieldDisabled = true
      this.editedQuotationIndex = this.quotationList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedQuotation = JSON.parse(str)
      this.tempQuotation = JSON.parse(str)
      if (this.editedQuotation.SignDate !== 0) {
        this.fileDate = this.convertToDateTimeFormat(this.editedQuotation.SignDate)
      }
      this.selectQuotationTerm = JSON.parse(
        JSON.stringify(this.editedQuotation.SelectQuotationTerm)
      )
      if (this.editedQuotation.IsThrowTransferOrder) {
        let response = await HttpTransferOrder.GetTransferOrderNumberStatusIsDone({
          number: this.editedQuotation.TransferOrderNumber
        })
        this.isDoneTransferOrderNumberStatus =
          response && response.status === 200 ? response.data.Data : false
      }
      await this.getCustomerLicensePlateList()
      await this.getCustomerOriginalLicenseLicensePlateList()
      await this.getStockFlow()
      this.isShowEditQuotationDialog = true
    },
    async getStockFlow () {
      if (this.editedQuotation.Type === this.quotationType.TypeTryInstall) {
        await this.getTryInstallItemsTempStock()
      } else if (
        this.editedQuotation.Type === this.quotationType.TypeNewInstall ||
        this.editedQuotation.Type === this.quotationType.TypeReturnCar ||
        this.editedQuotation.Type === this.quotationType.TypeMove
      ) {
        await this.getQuotationItemsTempStock()
      }
    },
    isShowDeleteQuotationDialogBtn (item) {
      this.editedQuotationIndex = this.quotationList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedQuotation = JSON.parse(str)
      this.isShowDeleteQuotationDialog = true
    },
    async closeEditedQuotation () {
      this.isLoadingQuotation = true
      await this.getAllQuotation()
      this.isShowEditQuotationDialog = false
      this.isCopy = false
      this.isAllTextFieldDisabled = false
      this.isLoadingQuotation = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultQuotation)
        this.editedQuotation = JSON.parse(str)
        this.tempQuotation = JSON.parse(str)
        this.fileDate = ''
        this.editedQuotationIndex = -1
        this.selectQuotationTerm = ''
        this.errorMessage = ''
        this.existErrorMessage = ''
        this.quantityErrorMessage = ''
      })
    },
    async confirmDeleteQuotation () {
      this.isLoadingSaveBtn = true
      this.isAllTextFieldDisabled = true
      this.isLoadingQuotation = true
      if (this.deleteQuotationSource) {
        this.deleteQuotationSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.deleteQuotationSource = cancelToken.source()
      await HttpQuotation.DeleteQuotation(
        this.quotationList[this.editedQuotationIndex].Id,
        this.deleteQuotationSource.token
      )
      this.deleteQuotationSource = null
      await this.getAllQuotation()
      this.closeDeleteQuotation()
    },
    closeDeleteQuotation () {
      this.isShowDeleteQuotationDialog = false
      this.isShowEditQuotationDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisabled = false
      this.isLoadingQuotation = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultQuotation)
        this.editedQuotation = JSON.parse(str)
        this.editedQuotationIndex = -1
      })
    },
    async saveEditedQuotation () {
      // 條款內容為空時禁止儲存
      if (!this.checkQuotationTerm()) return
      // 品項需同時包含授權(SU)與門號(VC)
      if (!this.checkAuthAndPhoneItems()) return
      this.errorMessage = ''
      this.existErrorMessage = ''
      this.quantityErrorMessage = ''
      await this.checkHasRepairPrice()
      await this.checkRepairQuotationIsExist()
      this.checkQuantity()
      this.changeTaxType()
      this.checkAddRentWarrantyPeriod()
      if (!this.errorMessage && !this.existErrorMessage && !this.quantityErrorMessage) {
        const isValid = await this.$refs.dialog.validate()
        if (!isValid) {
          alert('請確認必填欄位是否已正確填寫（標示 * 的欄位為必填）')
          return
        }
        if (
          this.editedQuotation.QuotationItems.length === 0 &&
          this.editedQuotation.Type === this.quotationType.TypeNewInstall
        ) {
          this.isQuotationItemNullDialog = true
        } else {
          let index = 0
          this.infoTempStockMessageList = []
          if (
            this.editedQuotation.Type === this.quotationType.TypeNewInstall ||
            this.editedQuotation.Type === this.quotationType.TypeReturnCar ||
            this.editedQuotation.Type === this.quotationType.TypeMove
          ) {
            this.editedQuotation.QuotationItems.forEach((element) => {
              if (element.Number) {
                if (element.TempStockQuantity - element.TotalQuantity <= 0) {
                  index++
                  this.infoTempStockMessageList.push({
                    Index: index,
                    BomName: '',
                    BomDescribe: '',
                    Number: element.Number,
                    Name: element.Name,
                    TempStockQuantity: element.TempStockQuantity,
                    NeedQuantity: element.TotalQuantity
                  })
                }
              } else {
                element.BomItems.forEach((ele) => {
                  if (ele.TempStockQuantity - ele.TotalQuantity <= 0) {
                    index++
                    this.infoTempStockMessageList.push({
                      Index: index,
                      BomName: element.Name,
                      BomDescribe: element.Describe,
                      Number: ele.Number,
                      Name: ele.Name,
                      TempStockQuantity: ele.TempStockQuantity,
                      NeedQuantity: ele.TotalQuantity
                    })
                  }
                })
              }
            })
          } else if (this.editedQuotation.Type === this.quotationType.TypeTryInstall) {
            this.editedQuotation.TryInstallItems.forEach((element) => {
              if (element.Number) {
                if (element.TempStockQuantity - element.TotalQuantity <= 0) {
                  index++
                  this.infoTempStockMessageList.push({
                    Index: index,
                    BomName: '',
                    BomDescribe: '',
                    Number: element.Number,
                    Name: element.Name,
                    TempStockQuantity: element.TempStockQuantity,
                    NeedQuantity: element.TotalQuantity
                  })
                }
              } else {
                element.BomItems.forEach((ele) => {
                  if (ele.TempStockQuantity - ele.TotalQuantity <= 0) {
                    index++
                    this.infoTempStockMessageList.push({
                      Index: index,
                      BomName: element.Name,
                      BomDescribe: element.Describe,
                      Number: ele.Number,
                      Name: ele.Name,
                      TempStockQuantity: ele.TempStockQuantity,
                      NeedQuantity: ele.TotalQuantity
                    })
                  }
                })
              }
            })
          }
          if (this.infoTempStockMessageList.length > 0) {
            this.isShowCheckTempStockDialog = true
          } else {
            await this.saveQuotation()
          }
        }
      }
    },
    checkAddRentWarrantyPeriod () {
      // 驗證 RenewMonthItems 的合約期數
      if (
        this.editedQuotation.Type === this.quotationType.TypeRenew &&
        this.editedQuotation.MonthItems &&
        this.editedQuotation.MonthItems.length > 0
      ) {
        // 按 ItemNumber 分組計算增加合約期數總和
        let renewItemGroups = {}
        this.editedQuotation.RenewMonthItems.forEach((renewItem) => {
          if (!renewItemGroups[renewItem.Number]) {
            renewItemGroups[renewItem.Number] = 0
          }
          renewItemGroups[renewItem.Number] += renewItem.AddRentWarrantyPeriod || 0
        })

        // 檢查每個品號的增加合約期數總和是否小於原合約期數
        let errors = []
        for (let itemNumber in renewItemGroups) {
          let monthItem = this.editedQuotation.MonthItems.find((item) => item.Number === itemNumber)
          if (monthItem && renewItemGroups[itemNumber] < monthItem.RentWarrantyPeriod) {
            errors.push(
              `品號 ${itemNumber} 的增加合約期數總和 (${renewItemGroups[itemNumber]}) 已經小於原合約期數 (${monthItem.RentWarrantyPeriod})`
            )
          }
        }

        // 如果有錯誤，顯示所有錯誤訊息
        if (errors.length > 0) {
          alert(errors.join('\n'))
        }
      }
    },
    async saveQuotation () {
      this.isLoadingSaveBtn = true
      this.isAllTextFieldDisabled = true
      if (this.editedQuotation.NumberType === null) {
        this.editedQuotation.NumberType = 0
      }
      if (this.editedQuotationIndex > -1) {
        if (this.updateQuotationSource) {
          this.updateQuotationSource.cancel('cancel')
        }
        let cancelToken = axios.CancelToken
        this.updateQuotationSource = cancelToken.source()
        await HttpQuotation.UpdateQuotation(this.editedQuotation, this.updateQuotationSource.token)
        this.updateQuotationSource = null
      } else {
        this.addCopyPageRecord()
        if (this.addQuotationSource) {
          this.addQuotationSource.cancel('cancel')
        }
        let cancelToken = axios.CancelToken
        this.addQuotationSource = cancelToken.source()
        await HttpQuotation.AddQuotation(this.editedQuotation, this.addQuotationSource.token)
        this.addQuotationSource = null
      }

      await this.getAllQuotation()
      await this.searchEditQuotation()
      await this.getStockFlow()
      this.tempQuotation = JSON.parse(JSON.stringify(this.editedQuotation))
      this.editedQuotationIndex = this.quotationList.findIndex(
        (x) => x.Number === this.editedQuotation.Number && x.Type === this.editedQuotation.Type
      )
      this.isLoadingSaveBtn = false
      this.isShowCheckTempStockDialog = false
    },
    async addCopyPageRecord () {
      if (this.isCopy) {
        await HttpPageChangeRecord.AddCopyQuotationRecord(this.editedQuotation.Number)
      }
    },
    setNewInstall (items) {
      this.editedQuotation.QuotationItems = JSON.parse(JSON.stringify(items))
    },
    getEditNewInstallIndex (val) {
      this.editedQuotationNewInstallIndex = val
    },
    async getEditNewInstall (val) {
      if (this.editedQuotationNewInstallIndex > -1) {
        if (this.editedQuotationNewInstallBomItemIndex !== -1) {
          this.editedQuotation.QuotationItems[this.editedQuotationNewInstallIndex].BomItems.splice(
            this.editedQuotationNewInstallBomItemIndex,
            1,
            val
          )
          this.editedQuotation.QuotationItems = JSON.parse(
            JSON.stringify(this.editedQuotation.QuotationItems)
          )
        } else {
          this.editedQuotation.QuotationItems.splice(this.editedQuotationNewInstallIndex, 1, val)
        }
      } else {
        if (this.editedQuotationNewInstallBomItemIndex !== -1) {
          this.editedQuotation.QuotationItems[this.editedQuotationNewInstallIndex].BomItems.push(
            val
          )
          this.editedQuotation.QuotationItems = JSON.parse(
            JSON.stringify(this.editedQuotation.QuotationItems)
          )
        } else {
          this.editedQuotation.QuotationItems.push(val)
        }
      }
      await this.getQuotationItemsTempStock()
      this.computedAmt()
    },
    computedAmt () {
      let itemTotal = 0
      let monthTotal = 0
      let payTotal = 0
      if (
        this.editedQuotation.Type === this.quotationType.TypeRepair ||
        this.editedQuotation.Type === this.quotationType.TypeOffset
      ) {
        this.editedQuotation.OffsetItems.forEach((element) => {
          itemTotal += element.TotalPrice * 1
        })
      }
      if (
        this.editedQuotation.Type === this.quotationType.TypeNewInstall ||
        this.editedQuotation.Type === this.quotationType.TypeReturnCar ||
        this.editedQuotation.Type === this.quotationType.TypeMove ||
        this.editedQuotation.Type === this.quotationType.TypeProject
      ) {
        this.editedQuotation.QuotationItems.forEach((element) => {
          if (!element.IsOptionalItem) {
            itemTotal += element.TotalPrice * 1
          }
        })
      }
      if (
        this.editedQuotation.Type === this.quotationType.TypeNewInstall ||
        this.editedQuotation.Type === this.quotationType.TypeReturnCar ||
        this.editedQuotation.Type === this.quotationType.TypeMonth ||
        this.editedQuotation.Type === this.quotationType.TypeProject ||
        this.editedQuotation.Type === this.quotationType.TypeTryInstall
      ) {
        this.editedQuotation.MonthItems.forEach((element) => {
          const quantityMultiplier =
            element.PayType === this.payType.Quantity
              ? Math.max(0, element.PayQuantity * 1 + element.AddPayQuantity * 1)
              : 1
          monthTotal +=
            element.DiscountPrice * element.RentQuantity * element.Quantity * quantityMultiplier * 1
        })
      }
      this.editedQuotation.PayItems.forEach((element) => {
        payTotal += element.DiscountPrice * element.BuyQuantity * 1
      })

      if (this.editedQuotation.Type === this.quotationType.TypeMove) {
        this.editedQuotation.MoveMonthItems.forEach((element) => {
          const quantityMultiplier =
            element.PayType === this.payType.Quantity
              ? Math.max(
                0,
                element.PayQuantity * 1 +
                    element.AddPayQuantity * 1 -
                    element.StopPayQuantity * 1
              )
              : 1
          monthTotal +=
            element.DiscountPrice *
            element.ReturnQuantity *
            element.Quantity *
            quantityMultiplier *
            1
        })
      }
      if (
        this.regexPrice.test(this.editedQuotation.ItemDiscount) &&
        this.regexPrice.test(this.editedQuotation.PayDiscount)
      ) {
        if (
          this.editedQuotation.Customer.InvoiceType * 1 ===
          this.invoiceType.DuplicateUniformInvoice
        ) {
          this.editedQuotation.ItemAmt = Math.round(itemTotal / 1.05)
          this.editedQuotation.ItemDiscountPrice =
            this.editedQuotation.ItemAmt - this.editedQuotation.ItemDiscount
          this.editedQuotation.ItemTax = Math.round(this.editedQuotation.ItemDiscountPrice * 0.05)
          this.editedQuotation.ItemTotalAmt =
            this.editedQuotation.ItemDiscountPrice + this.editedQuotation.ItemTax

          this.editedQuotation.MonthAmt = Math.round(monthTotal / 1.05)
          this.editedQuotation.MonthTax = Math.round((monthTotal / 1.05) * 0.05)
          this.editedQuotation.MonthTotalAmt = monthTotal

          this.editedQuotation.PayAmt = Math.round(payTotal / 1.05)
          this.editedQuotation.PayDiscountPrice =
            this.editedQuotation.PayAmt - this.editedQuotation.PayDiscount
          this.editedQuotation.PayTax = Math.round(this.editedQuotation.PayDiscountPrice * 0.05)
          this.editedQuotation.PayTotalAmt =
            this.editedQuotation.PayDiscountPrice + this.editedQuotation.PayTax
        } else {
          this.editedQuotation.ItemAmt = itemTotal
          this.editedQuotation.ItemDiscountPrice = itemTotal - this.editedQuotation.ItemDiscount
          this.editedQuotation.ItemTax = Math.round(this.editedQuotation.ItemDiscountPrice * 0.05)
          this.editedQuotation.ItemTotalAmt = Math.round(
            this.editedQuotation.ItemDiscountPrice * 1.05
          )

          this.editedQuotation.MonthAmt = monthTotal
          this.editedQuotation.MonthTax = Math.round(this.editedQuotation.MonthAmt * 0.05)
          this.editedQuotation.MonthTotalAmt = Math.round(this.editedQuotation.MonthAmt * 1.05)

          this.editedQuotation.PayAmt = payTotal
          this.editedQuotation.PayDiscountPrice =
            this.editedQuotation.PayAmt - this.editedQuotation.PayDiscount
          this.editedQuotation.PayTax = Math.round(this.editedQuotation.PayDiscountPrice * 0.05)
          this.editedQuotation.PayTotalAmt = Math.round(
            this.editedQuotation.PayDiscountPrice * 1.05
          )
        }
      }
    },
    getEditNewInstallBomItemIndex (val) {
      this.editedQuotationNewInstallBomItemIndex = val
    },
    getNewInstallDeleteBomItemIndex (val) {
      this.deleteQuotationNewInstallBomItemIndex = val
    },
    getNewInstallDeleteIndex (val) {
      this.deleteQuotationNewInstallIndex = val
    },
    getNewInstallDelete () {
      if (this.deleteQuotationNewInstallBomItemIndex !== -1) {
        this.editedQuotation.QuotationItems[this.deleteQuotationNewInstallIndex].BomItems.splice(
          this.deleteQuotationNewInstallBomItemIndex,
          1
        )
      } else {
        this.editedQuotation.QuotationItems.splice(this.deleteQuotationNewInstallIndex, 1)
      }
      this.computedAmt()
    },
    setMonthItemIndex (val) {
      this.monthItemIndex = val
    },
    setMonthBomItemIndex (val) {
      this.monthBomItemIndex = val
    },
    setAllMonth (items) {
      this.editedQuotation.MonthItems = JSON.parse(JSON.stringify(items))
    },
    setBomMonth () {
      let totalPrice = 0
      let totalDiscount = 0
      this.editedQuotation.MonthItems[this.monthItemIndex].MonthBomItems.forEach((element) => {
        totalPrice += element.Price * 1
        totalDiscount += element.Discount * 1
      })
      this.editedQuotation.MonthItems[this.monthItemIndex].Price = totalPrice
      this.editedQuotation.MonthItems[this.monthItemIndex].Discount = totalDiscount
      this.editedQuotation.MonthItems[this.monthItemIndex].DiscountPrice =
        totalPrice - totalDiscount
      this.editedQuotation.MonthItems[this.monthItemIndex].TotalPrice =
        this.editedQuotation.MonthItems[this.monthItemIndex].DiscountPrice *
        this.editedQuotation.MonthItems[this.monthItemIndex].Quantity *
        this.editedQuotation.MonthItems[this.monthItemIndex].RentQuantity *
        1
      this.editedQuotation.MonthItems = JSON.parse(JSON.stringify(this.editedQuotation.MonthItems))
      this.computedAmt()
    },
    setMonthItem (val) {
      if (this.monthItemIndex > -1) {
        if (this.monthBomItemIndex !== -1) {
          this.editedQuotation.MonthItems[this.monthItemIndex].MonthBomItems.splice(
            this.monthBomItemIndex,
            1,
            val
          )
          this.editedQuotation.MonthItems = JSON.parse(
            JSON.stringify(this.editedQuotation.MonthItems)
          )
        } else {
          this.editedQuotation.MonthItems.splice(this.monthItemIndex, 1, val)
        }
      } else {
        if (this.monthBomItemIndex !== -1) {
          this.editedQuotation.MonthItems[this.monthItemIndex].MonthBomItems.push(val)
          this.editedQuotation.MonthItems = JSON.parse(
            JSON.stringify(this.editedQuotation.MonthItems)
          )
        } else {
          this.editedQuotation.MonthItems.push(val)
        }
      }
      this.computedAmt()
    },
    deleteMonthItem () {
      let monthItem = this.editedQuotation.MonthItems[this.monthItemIndex]

      if (this.monthBomItemIndex !== -1) {
        this.editedQuotation.DiscountItems = this.editedQuotation.DiscountItems.filter(
          (x) => x.MonthItemNumber !== monthItem.MonthBomItems[this.monthBomItemIndex].Number
        )
        monthItem.MonthBomItems.splice(this.monthBomItemIndex, 1)
      } else {
        if (!monthItem.Number && monthItem.MonthBomItems && monthItem.MonthBomItems.length > 0) {
          monthItem.MonthBomItems.forEach((element) => {
            this.editedQuotation.DiscountItems = this.editedQuotation.DiscountItems.filter(
              (x) => x.MonthItemNumber !== element.Number
            )
          })
        } else {
          if (monthItem.Number) {
            this.editedQuotation.DiscountItems = this.editedQuotation.DiscountItems.filter(
              (x) => x.MonthItemNumber !== monthItem.Number
            )
          } else {
            this.editedQuotation.DiscountItems = this.editedQuotation.DiscountItems.filter(
              (x) => x.MonthItemName !== monthItem.Name
            )
          }
        }

        this.editedQuotation.MonthItems.splice(this.monthItemIndex, 1)
      }
      if (this.editedQuotation.MonthItems.length === 0) {
        this.editedQuotation.DiscountItems = []
      }
      this.computedAmt()
    },
    setAllPay (items) {
      this.editedQuotation.PayItems = JSON.parse(JSON.stringify(items))
    },
    setPayItemIndex (val) {
      this.payItemIndex = val
    },
    setPayItem (val) {
      if (this.payItemIndex === -1) {
        this.editedQuotation.PayItems.push(val)
      } else {
        this.editedQuotation.PayItems.splice(this.payItemIndex, 1, val)
      }
      this.computedAmt()
    },
    deletePayItem (val) {
      this.editedQuotation.PayItems.splice(val, 1)
      this.computedAmt()
    },

    getEditRemoveCarIndex (val) {
      this.editedQuotationRemoveCarIndex = val
    },
    getDeleteRemoveCarIndexToDelete (val) {
      this.editedQuotation.RemovedItems.splice(val, 1)
    },
    getEditRemoveCar (val) {
      if (this.editedQuotationRemoveCarIndex > -1) {
        this.editedQuotation.RemovedItems.splice(this.editedQuotationRemoveCarIndex, 1, val)
      } else {
        this.editedQuotation.RemovedItems.push(val)
      }
    },
    setRemoveOffsetItem (items) {
      this.editedQuotation.OffsetItems = JSON.parse(JSON.stringify(items))
    },
    setRemove (items) {
      this.editedQuotation.RemovedItems = JSON.parse(JSON.stringify(items))
    },
    setNewItem (items) {
      this.editedQuotation.QuotationItems = JSON.parse(JSON.stringify(items))
    },
    async getNewItem (val) {
      if (this.newItemIndex > -1) {
        if (this.newBomItemIndex !== -1) {
          this.editedQuotation.QuotationItems[this.newItemIndex].BomItems.splice(
            this.newBomItemIndex,
            1,
            val
          )
        } else {
          this.editedQuotation.QuotationItems.splice(this.newItemIndex, 1, val)
        }
      } else {
        if (this.newBomItemIndex !== -1) {
          this.editedQuotation.QuotationItems[this.newItemIndex].BomItems.push(val)
        } else {
          this.editedQuotation.QuotationItems.push(val)
        }
      }
      await this.getQuotationItemsTempStock()
      this.computedAmt()
    },
    getNewItemIndex (val) {
      this.newItemIndex = val
    },
    getNewItemBomItemIndex (val) {
      this.newBomItemIndex = val
    },
    getDeleteNewBomItemIndex (val) {
      this.deleteNewBomItemIndex = val
    },
    getNewItemDeleteIndex (val) {
      this.deleteNewItemIndex = val
      if (this.deleteNewBomItemIndex !== -1) {
        this.editedQuotation.QuotationItems[this.deleteNewItemIndex].BomItems.splice(
          this.deleteNewBomItemIndex,
          1
        )
      } else {
        this.editedQuotation.QuotationItems.splice(this.deleteNewItemIndex, 1)
      }
      this.computedAmt()
    },
    getReturnItemIndex (val) {
      this.returnItemIndex = val
    },
    setReturn (items) {
      this.editedQuotation.ReturnItems = JSON.parse(JSON.stringify(items))
    },
    getEditedReturnItem (val) {
      if (this.returnItemIndex !== -1) {
        this.editedQuotation.ReturnItems.splice(this.returnItemIndex, 1, val)
      } else {
        this.editedQuotation.ReturnItems.push(val)
      }
    },
    getReturnItemDeleteIndex (val) {
      this.editedQuotation.ReturnItems.splice(val, 1)
    },
    setOffsetItem (val) {
      this.editedQuotation.OffsetItems = JSON.parse(JSON.stringify(val))
    },
    setEditedOffsetItem (val) {
      if (this.offsetItemIndex === -1) {
        this.editedQuotation.OffsetItems.push(val)
      } else {
        this.editedQuotation.OffsetItems.splice(this.offsetItemIndex, 1, val)
      }
      this.computedAmt()
    },
    setOffsetItemIndex (val) {
      this.offsetItemIndex = val
    },
    deleteOffsetItem (val) {
      this.editedQuotation.OffsetItems.splice(val, 1)
      this.computedAmt()
    },
    setDiscountItem (val) {
      if (this.discountItemIndex === -1) {
        if (val.DiscountType !== 2) {
          if (val.MonthItemId === '' || val.MonthItemId === null) {
            let monthList =
              this.editedQuotation.Type === this.quotationType.TypeMove
                ? this.editedQuotation.MoveMonthItems
                : this.editedQuotation.MonthItems
            monthList.forEach((element) => {
              if (!element.Number && element.MonthBomItems && element.MonthBomItems.length > 0) {
                element.MonthBomItems.forEach((ele) => {
                  this.editedQuotation.DiscountItems.push({
                    DiscountId: this.generateObjectId(),
                    WaitForDiscountIds: val.WaitForDiscountIds,
                    DiscountType: val.DiscountType,
                    MonthWarrantyPeriod: ele.RentWarrantyPeriod,
                    MonthItemId: ele.Id,
                    MonthItemName: ele.Name,
                    MonthItemNumber: ele.Number,
                    IsRepeat: val.IsRepeat,
                    RepeatWarrantyPeriod: val.RepeatWarrantyPeriod,
                    GivePrepayment: val.GivePrepayment,
                    GiveWarrantyPeriod: val.GiveWarrantyPeriod,
                    GiveMoney: val.GiveMoney,
                    GiveDay: val.GiveDay,
                    GivePercent: val.GivePercent,
                    UseDiscountType: val.UseDiscountType,
                    UseWarrantyPeriods: val.UseWarrantyPeriods,
                    Remark: val.Remark,
                    Month: val.Month,
                    Months: val.Months
                  })
                })
              } else {
                if (!element.MonthNumber) {
                  this.editedQuotation.DiscountItems.push({
                    DiscountId: this.generateObjectId(),
                    WaitForDiscountIds: val.WaitForDiscountIds,
                    DiscountType: val.DiscountType,
                    MonthWarrantyPeriod: element.RentWarrantyPeriod,
                    MonthItemId: element.Id,
                    MonthItemName: element.Name,
                    MonthItemNumber: element.Number,
                    IsRepeat: val.IsRepeat,
                    RepeatWarrantyPeriod: val.RepeatWarrantyPeriod,
                    GivePrepayment: val.GivePrepayment,
                    GiveWarrantyPeriod: val.GiveWarrantyPeriod,
                    GiveMoney: val.GiveMoney,
                    GivePercent: val.GivePercent,
                    GiveDay: val.GiveDay,
                    UseDiscountType: val.UseDiscountType,
                    UseWarrantyPeriods: val.UseWarrantyPeriods,
                    Remark: val.Remark,
                    Month: val.Month,
                    Months: val.Months
                  })
                }
              }
            })
          } else {
            val.DiscountId = this.generateObjectId()
            this.editedQuotation.DiscountItems.push(val)
          }
        } else {
          val.DiscountId = this.generateObjectId()
          this.editedQuotation.DiscountItems.push(val)
        }
      } else {
        this.editedQuotation.DiscountItems.splice(this.discountItemIndex, 1, val)
      }
    },
    generateObjectId () {
      const timestamp = Math.floor(Date.now() / 1000)
        .toString(16)
        .padStart(8, '0')
      const randomBytes = Array.from({ length: 16 }, () =>
        Math.floor(Math.random() * 16).toString(16)
      ).join('')
      return timestamp + randomBytes
    },
    setDiscountItemIndex (val) {
      this.discountItemIndex = val
    },
    deleteDiscountItem (val) {
      this.editedQuotation.DiscountItems.splice(val, 1)
    },
    setAllDiscount (items) {
      this.editedQuotation.DiscountItems = JSON.parse(JSON.stringify(items))
    },
    setMoveItemIndex (val) {
      this.moveItemIndex = val
    },
    setMove (items) {
      this.editedQuotation.MoveItems = JSON.parse(JSON.stringify(items))
    },
    setEditedMoveItem (val) {
      if (this.moveItemIndex !== -1) {
        this.editedQuotation.MoveItems.splice(this.moveItemIndex, 1, val)
      } else {
        this.editedQuotation.MoveItems.push(val)
      }
    },
    setMoveItemDeleteIndex (val) {
      this.editedQuotation.MoveItems.splice(val, 1)
    },

    setMoveMonthItem (val) {
      if (this.monthItemIndex !== -1) {
        this.editedQuotation.MoveMonthItems.splice(this.monthItemIndex, 1, val)
      } else {
        this.editedQuotation.MoveMonthItems.push(val)
      }
      this.computedAmt()
    },
    deleteMoveMonthItem () {
      let monthItem = this.editedQuotation.MoveMonthItems[this.monthItemIndex]

      this.editedQuotation.DiscountItems = this.editedQuotation.DiscountItems.filter(
        (x) => x.MonthItemNumber !== monthItem.Number
      )

      this.editedQuotation.MoveMonthItems.splice(this.monthItemIndex, 1)
      if (this.editedQuotation.MoveMonthItems.length === 0) {
        this.editedQuotation.DiscountItems = []
      }
      this.computedAmt()
    },
    setAllMoveMonth (items) {
      this.editedQuotation.MoveMonthItems = JSON.parse(JSON.stringify(items))
    },
    setTryInstall (items) {
      this.editedQuotation.TryInstallItems = JSON.parse(JSON.stringify(items))
    },
    setTryInstallIndex (val) {
      this.editedQuotationTryInstallIndex = val
    },
    async setEditTryInstall (val) {
      if (this.editedQuotationTryInstallIndex > -1) {
        if (this.editedQuotationTryInstallBomItemIndex !== -1) {
          this.editedQuotation.TryInstallItems[this.editedQuotationTryInstallIndex].BomItems.splice(
            this.editedQuotationTryInstallBomItemIndex,
            1,
            val
          )
          this.editedQuotation.TryInstallItems = JSON.parse(
            JSON.stringify(this.editedQuotation.TryInstallItems)
          )
        } else {
          this.editedQuotation.TryInstallItems.splice(this.editedQuotationTryInstallIndex, 1, val)
        }
      } else {
        if (this.editedQuotationTryInstallBomItemIndex !== -1) {
          this.editedQuotation.TryInstallItems[this.editedQuotationTryInstallIndex].BomItems.push(
            val
          )
          this.editedQuotation.TryInstallItems = JSON.parse(
            JSON.stringify(this.editedQuotation.TryInstallItems)
          )
        } else {
          this.editedQuotation.TryInstallItems.push(val)
        }
      }
      await this.getTryInstallItemsTempStock()
    },
    setTryInstallDeleteIndex (val) {
      this.deleteQuotationTryInstallIndex = val
    },
    setTryInstallEditBomItemIndex (val) {
      this.editedQuotationTryInstallBomItemIndex = val
    },
    setTryInstallDeleteBomItemIndex (val) {
      this.deleteQuotationTryInstallBomItemIndex = val
    },
    setDeleteTryInstall () {
      if (this.editedQuotationTryInstallBomItemIndex !== -1) {
        this.editedQuotation.TryInstallItems[this.deleteQuotationTryInstallIndex].BomItems.splice(
          this.deleteQuotationTryInstallBomItemIndex,
          1
        )
      } else {
        this.editedQuotation.TryInstallItems.splice(this.deleteQuotationTryInstallIndex, 1)
      }
    },
    // isPreview=true 代表簽核前預覽，檔名加上 預覽_ 前綴
    async exportTryInstallQuotation (isPreview = false) {
      let response = await HttpQuotation.ExportTryInstallQuotation(this.editedQuotation, isPreview)
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const aEle = document.createElement('a') // 創建a標籤
        const href = window.URL.createObjectURL(blob) // 創建下載的鏈接
        aEle.href = href
        aEle.download =
          (isPreview ? '預覽_' : '') +
          '試裝_' +
          this.editedQuotation.Number +
          '_' +
          this.editedQuotation.Customer.ShortName.slice(0, 4) +
          '_' +
          this.$moment(this.editedQuotation.CreateTime).format('YYYYMMDD_HHmmss') +
          '.xlsx' // 下載後文件名
        document.body.appendChild(aEle)
        aEle.click() // 點擊下載
        document.body.removeChild(aEle) // 下載完成移除元素
        window.URL.revokeObjectURL(href) // 釋放掉blob對象
      }
      if (!isPreview) await this.searchEditQuotation()
    },
    async getIsConfirmTryInstallQuotations () {
      if (this.editedQuotation.LicensePlateList.length === 0) {
        return
      }
      let response = await HttpQuotation.GetIsConfirmTryInstallQuotations({
        customerId: this.editedQuotation.Customer.Id,
        licensePlate: this.editedQuotation.LicensePlateList[0]
      })
      this.tryInstallQuotationList = response.status === 200 ? response.data.Data : []
    },
    setEditedRenewMonthItemIndex (val) {
      this.renewMonthItemIndex = val
    },
    setEditedRenewMonthItem (val) {
      if (this.renewMonthItemIndex !== -1) {
        this.editedQuotation.RenewMonthItems.splice(this.renewMonthItemIndex, 1, val)
      } else {
        this.editedQuotation.RenewMonthItems.push(val)
      }
    },
    deleteRenewMonthItem () {
      this.editedQuotation.RenewMonthItems.splice(this.renewMonthItemIndex, 1)
    }
  },
  components: {
    NewInstallCar,
    RemoveCar,
    ReturnCar,
    CustomerAutocompleteFilter,
    DeleteDialog,
    DatePickerSignDate,
    DatePickerExpDate,
    QuotationCustomerAutocomplete,
    VueEditor,
    Repair,
    Month,
    DatePickerSetTime,
    Offset,
    MoveCar,
    Project,
    SelectMergeQuotation,
    QuotationChangeDetail,
    DatePickerSetTimeNotRequest,
    FixNumberAutocomplete,
    RepairNumberAutocomplete,
    TryInstall,
    AcceptanceNumberAutocomplete,
    QuotationCustomerCombobox,
    NotInvalidBtn,
    RenewMonthSetting,
    ProjectPayItem,
    LicensePlateBatchInputButton
  }
}
</script>
